export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
    "AUDIT_UserDeviceService_extCode": "extCode",
    "MdmPolicyControlName_WLANScanMode": "WLAN ScanMode",
    "LANG_loadRemoteConrolPage": "Would you like to move to the device remote control page?",
    "LANG_SETTING_OrganManagementDetail": "Manage department and organization.",
    "Hash": "Hash value",
    "MdmPolicyControlName_safariForceFraudWarning": "Safari fraud warning",
    "MdmPolicyControlName_encInMemory": "Internal memory encryption",
    "LANG_policyPublishToSave": "Save To Policy",
    "AUDIT_UserDeviceService_updateDate": "updateDate",
    "AUDIT_ControlAPService_updateDate": "updateDate",
    "RC_GET_SYSTEM_INFO": "System information views",
    "AUDIT_ControlAPService_createDate": "createDate",
    "LANG_ALT_addUser": "Add MDM user",
    "LANG_LOG_DeviceLog": "Device Log",
    "LANG_REMOTE_BACKUP_EXPLANATION": "You can backup important information of device to the server. If you click Refresh Button, you can see the last backup and recovery information.",
    "LANG_AP_ADD": "Add AP(Access Point)",
    "ACTION_DeviceService_sync": "Video synchronization and communication",
    "RC_POLICY_OFF": "Device Policy OFF",
    "BLACKAPPDEL": "Deletion",
    "LANG_modifyBlackApp": "Modify black app",
    "LANG_thus": "Thu",
    "IsUseFlag_Use": "USE",
    "MdmPolicyControlName_screenLockPattern": "Screen lock pattern",
    "MdmPolicyControlName_AllowStore": "Allow Store",
    "CertTerminated": "Terminated",
    "MdmPolicyControlName_allowOSUpdate": "Allow OS Update",
    "ERROR_unauthorized_phoneNumber": "Unauthorized Phone Number.",
    "Title_000000001": "시스템관리자",
    "ERROR_UserSessionTimeout": "Admin Timeout",
    "targetName": "Target name",
    "AUDIT_LocationService_name": "name",
    "MdmPolicyControlName_sendPeriodNormalLog": "General log upload period",
    "MdmPolicyControlName_AllowVPNOverCellular": "Allow VPN Over Cellular",
    "AUDIT_VisitorUserService_companyName": "companyName",
    "MESSAGE_ALERT_NOT_SELECT_TARGET": "The {0} target is not selected.",
    "LANG_DeviceAppMng": "Mobile APP management",
    "LANG_INITPW_ITEM_NEXT_TIME": "I'll change password Later...",
    "LANG_Date": "Date",
    "LANG_DEVICE_DeviceTypeManagementDetail": "Manage basic information like device model and OS.",
    "LANG_ReservedVisitorManagementList_VisitorDepartment": "Visit Department",
    "Configuration_securityEnabled": "Security restriction of log in",
    "LANG_APP_WhiteApp": "White app",
    "NotAfter": "Ends",
    "MdmPolicyControlName_AllowBrowser": "Allow Browser",
    "LANG_group": "Group",
    "AL_agentLock": "Does the screen lock",
    "LANG_DeviceType": "Device type",
    "LANG_SecurityIssueManageMent": "Security issues management",
    "AUDIT_Pkcs12CertificateService_id": "id",
    "NoticeSubject": "Notice title",
    "ISSUE_SOLVE_ERROR_UserLocked": "User-specified password exceeds the number of failures has been locked. If the \"user management\"-putting the lock Fu > \"user management\" in the \"unlock\".",
    "CONFIRM_TO_Delete": "Delete the dept should be selected with a single.",
    "MdmPolicyControlName_automaticLockScreenTime": "Screen self-locking time",
    "MESSAGE_ALERT_CONFIRM_INSERT": "Do you want to add?",
    "LANG_DEVICE_unlockToken": "Unlock Password",
    "LANG_deviceTypeDetail": "Detail device type",
    "MdmPolicyControlName_allowAirDrop": "Allow AirDrop",
    "APName": "AP name",
    "LANG_ValidateLogin": "Username and password is required.",
    "LANG_POLICY_callBlockingOff": "Call blocking : OFF",
    "TargetCommand": "Delete",
    "MdmPolicyControlName_forceEncryptedBackup": "Force encrypted backup",
    "Operation_DELETE": "Delete Complete",
    "MdmPolicyControlName_allowExplicitContent": "Allow contents to be purchased",
    "ISSUE_SOLVE_GUIDE_DeviceManagerDisabled": "In order to safely use the appliance Manager appliance administrator to request active. As shown below, please note that the Device Manager is active. Terminal \"system settings\"-> \"security\"-If you select the \"Device Manager\" >, visible in the app list, please check the \"ExafeMDM\".",
    "Audit_ControlAPService": "WiFi AP",
    "Title_Director": "Director",
    "Status_FIXED": "Fix",
    "ISSUE_SOLVE_DeviceRooting": "The user's machine has been rooting. For security reasons, the terminal block in the data, are you sure you want to leave?",
    "jqGrid_search": "Search",
    "MdmPolicyControlName_MaxDevicePasswordFailedAttempts": "Max Device Password Failed Attempts",
    "LANG_PolicyName": "Policy Name",
    "AUDIT_VersionedAppService_installedApp": "installedApp",
    "LANG_count": "Count",
    "AUDIT_VersionedAppService_virusResult": "virusResult",
    "LANG_LostStatusTime": "Lost Time",
    "AUDIT_VersionedAppService_officeApp": "officeApp",
    "ACTION_SystemLockedRemote": "Admin System locked",
    "LANG_SMS": "SMS SEND",
    "MdmPolicyControlName_allowMultipleUsers": "Allow multiple users",
    "LANG_policyTargetTitle": "Target of Policy Application",
    "AUDIT_HolidaysService_createDate": "createDate",
    "LANG_Consent_Person_info": "Consent To Person Info",
    "MdmPolicyControlName_AllowCellularDataRoaming": "Allow Cellular Data Roaming ",
    "LANG_WP_federated_enrollment_ERROR_exception": "System Error. Ask to your System Administrator",
    "LANG_TOP_PersonnelManagement": "Personnel Management",
    "MINUTE05": "5 min",
    "Configuration_sessionMaxInactiveInterval_ALERT": "{0} : the value must be between 300 to 1800, please specify.",
    "AUDIT_VersionedAppService_packageName": "packageName",
    "UserName": "User-ID",
    "MINUTE02": "2 min",
    "MINUTE01": "1 min",
    "AUDIT_UserService_updateDate": "updateDate",
    "MESSAGE_ALERT_DEFAULT_POLICY_NOT_DELETE": "You can not delete the default condition.",
    "LostTelNumber": "Phone number",
    "MdmPolicyControlName_sendLogLevel": "Transmission level of log",
    "EditAccessPoint": "Edit the wireless AP",
    "AllowedIP_Desc1": "You can not log in to the server other than allowed IP.",
    "LANG_POLICY_listConfigDetail": "Select function that will be controled when the MDM policy is performed.",
    "AllowedIP_Desc2": "Required to enter one, and you can enter up to two.",
    "MdmPolicyControlName_removalPassword": "Profile password",
    "sourceTypeTargetName": "Log source name",
    "LANG_INITPW_CONFIRM_PASSWORD": "Password changed successfully. relogin please.",
    "AUDIT_VisitorUserService_visitorType": "visitorType",
    "AUDIT_ControlAPService_ssID": "ssID",
    "AL_agentStop": "MDM results",
    "LANG_POLICY_CONDITION_POPUP": "(Popup)",
    "AUDIT_UserTitleService_updateDate": "updateDate",
    "ERROR_UserStatusIsNotUse": "Non Using User",
    "MINUTE10": "10 min",
    "LANG_RetainSessionTime": "Session retention time(sec)",
    "AUDIT_BeaconAreaService_createDate": "createDate",
    "LANG_LOGIN_DELETE_ERROR": "You can not delete your account manager.",
    "LANG_App_Upload_OfficeApp_is_Exists": "Office App is already exists.",
    "SAFARIACCEPTCOOKIES_VISITED_SITE": "Using in Visited Site",
    "IsUseFlag_NotUse": "NOT_USE",
    "LANG_Policy_TargetSave": "Success save to  Policy Target",
    "AddSecurityIssue": "Add security issues",
    "LANG_PhoneNumber": "Phone Number",
    "LANG_ManageCertificate": "Certificate management",
    "LANG_ReservedVisitorManagementRegister": "Reservations visitor registration",
    "LANG_WARNING_LEVEL2_MSG": "[EN]WARN Level : 단순한 오류에 대한 로그",
    "LANG_POLICY_CONDITION_TITLE_TYPE_TIME_SCOPE": "Time Scope",
    "MdmPolicyControlName_AllowInternetSharing": "Allow Internet Sharing",
    "LANG_ManagerConfig": "Administration configuration",
    "ERROR_DBLimitCritical": "Storage Critical limit exeed.",
    "AUDIT_VisitorUserService_visitorDeptName": "visitorDeptName",
    "LANG_DEVICE_PositionInfomation2": "Location details",
    "MdmPolicyControlName_maxPINAgeInDays": "Password use time (Day)",
    "AUDIT_VisitorUserService_visitorActionType": "visitorActionType",
    "AUDIT_UserService_username": "username",
    "Validation_alert": "[{0}] is required.",
    "LANG_SuccessToDeploy": "Deploy the policies to After saving.",
    "AUDIT_LocationService_longitude": "longitude",
    "LANG_PolicyIn": "IN Policy",
    "ACTION_DeviceInactiveMaximumTime": "Terminal operator not occurred",
    "LANG_Line10": "by 10 lines",
    "LANG_Company_Not_Found": "There is no company found.",
    "AUDIT_LocationService_areaCode": "areaCode",
    "Configuration_scepUrl_DESC": "Set a verification (CA) service URL for iPhone profile installation",
    "MdmPolicyControlName_typeBrightnessAdjustment": "Brightness adjustment type",
    "LANG_Windows_App_Select02": "Not configured.",
    "LANG_Windows_App_Select01": "Explicit allow unlock.",
    "LANG_APP_BusinessAppState": "Office app status",
    "LANG_NOTICE_ListNull": "There are no registered Notice.",
    "MdmPolicyControlName_safariAllowPopups": "Allow pop-ups",
    "ModifyNotice": "Notice the change",
    "LANG_Windows_App_Select00": "Explicit deny.",
    "LANG_LOG_AuditLatest": "Recent audit",
    "MdmPolicyControlName_forcePIN": "Password policy stutus",
    "PasswordPolicyAlphabet": "English characters",
    "Audit_AppService": "App",
    "TermRefresh": "Refresh",
    "LANG_SETTING_NoticeManagement": "Notice Management",
    "MdmPolicyControlName_AllowVPNRoamingOverCellular": "Allow VPN Roaming Over Cellular",
    "AUDIT_HolidaysService_id": "id",
    "LANG_UpdateDate": "Update Date",
    "LANG_DEVICE_AppManagement": "APP Management",
    "LANG_Line20": "by 20 lines",
    "AUDIT_ReservedVisitorService_id": "ID",
    "MdmPolicyControlName_PreventSmartScreenPromptOverride": "users can override the SmartScreen Filter warnings about potentially malicious websites.",
    "LANG_DEVICE_detailDevice": "See detail information of the device",
    "Configuration_encodeDvc_DESC": "To verify forgery app, set a encoding status of dynamic verification code",
    "Configuration_systemEmail_DESC": "In the event of a security issue, set an email to send notification for administrator",
    "LANG_msgAgentInstallState": "Check the status of installed MDM APP.",
    "LANG_SearchHere": "Direct retrieval",
    "MdmPolicyControlName_AllowScreenCapture": "Allow Screen Capture",
    "LANG_YYYYMMMM": "MMMM YYYY",
    "LANG_TargetUser": "User",
    "MdmPolicyControlName_AllowCortana": "Allow Cortana",
    "AUDIT_ThirdPartyCompanyService_companyType": "CompanyType",
    "LANG_YYYYMMMD": "MMM D YYYY",
    "LANG_titleDeptName": "Title/Dept",
    "selectTargetNoticeManagement": "Select Target Notice",
    "AUDIT_UserDeviceService_id": "id",
    "AUDIT_AppService_plistFilePath": "plistFilePath",
    "LANG_jan": "Jan",
    "Configuration_adminAccessIPEnabled_DESC": "Allowed IP managed by the server on or off.",
    "PolicyControl_new_category_6003": "Control to Edge. ",
    "LANG_LostStatusRelease": "Not Lost",
    "LANG_LOC_addLocation": "Add location",
    "PolicyControl_new_category_6000": "Windows OS",
    "WhiteAppAppointment": "Designation of white list",
    "RC_SENT": "Command transmission completed",
    "LANG_ReservedVisitorManagementList_VisitorCompetent": "Visit Competent",
    "LANG_VALIDATE_SEARCHVALUE_MESSAGE": "Enter the Search Value.",
    "MdmPolicyControlName_allowGPS": "GPS",
    "LANG_WP_federated_enrollment_item_user_password": "Password",
    "LANG_CompanyBy": "Company",
    "BUTTON_OK2": "Apply",
    "PASSWORD_QUALITY_SOMETHING": "The minimum lock-in",
    "LANG_DEVICE_DeviceRemoteManageDetail": "The management page that you can control a device remotely.",
    "LANG_Self_Device_location_status": "Confirm to location assent",
    "LANG_LocationPolicyApplys": "Apply",
    "ACTION_ApplicationStarted": "Security system / Audit log start",
    "RC_FOUND": "Releases the report of loss",
    "Status_ACTIVE": "Active",
    "ISSUE_SOLVE_ERROR_DeviceInactiveMaximumTime": "The device has no access record for longer than appointed time. Most of time, it may be turned off. However, it is possible that the location has bad communication environment or it might have connection problem with server. You have to contact the device to find out any security issue, and take appropriate action.",
    "MdmPolicyControlName_allowiTunes": "Allow ITunes",
    "AL_policyAppsApplyFail": "App Policy enforcement failed",
    "DeviceName": "Device Name",
    "LANG_YYYYMMMD_DAY": "MMM D YYYY",
    "LANG_POLICY_CONDITION": "Policy Condition",
    "MdmPolicyControlName_MSPASP0000000001": "App execution control",
    "policyControlList": "Currently selected MDM functions",
    "LANG_target2": "target",
    "MdmPolicyControlName_MSPASP0000000002": "Except for System Application",
    "MdmPolicyControlName_autoUpdateMdm": "MDM auto upgrade status",
    "MdmPolicyControlName_MSPASP0000000003": "Except for Market Application",
    "AUDIT_ControlAPService_pin": "pin",
    "MdmPolicyControlName_MSPASP0000000004": "Allow MDM features to be activated",
    "MdmPolicyControlName_MSPASP0000000006": "Control an automatic execution of app",
    "MdmPolicyControlName_MSPASP0000000008": "Option for app execution",
    "AUDIT_PassingStatusService_": "PassingStatusService",
    "AUDIT_UserDeviceService_allowedLocationMonitoring": "allowedLocationMonitoring",
    "MdmPolicyControlName_RequireDeviceEncryption": "Require Device Encryption",
    "BUTTON_RECOVERY": "RESTORE",
    "LANG_POLICY_listConfig": "Set Policy Item",
    "RC_OUTCALL_OFF": "Block to make a call",
    "MdmPolicyControlName_AntiTheftMode": "AntiTheft Mode",
    "AUDIT_UserDeviceService_unqKey": "unqKey",
    "LANG_App_Upload_BlackApp_is_Exists": "Black App is already exists.",
    "AUDIT_UserDeviceService_registered": "registered",
    "AUDIT_ThirdPartyCompanyService_ipPattern": "ipPattern",
    "AlertMailBody": "Hello {0}, for the following reason: {1)app is failed to verify. Message: {2)",
    "LANG_AdminName": "Admin name",
    "AUDIT_ReservedVisitorService_position": "[EN]방문자직책",
    "MdmPolicyControlName_minLength": "Minimum length of password",
    "BUTTON_APPINFO": "APP INFO",
    "AUDIT_HolidaysService_admin": "admin",
    "MdmPolicyControlName_AllowManualVPNConfiguration": "Allow Manual VPN Configuration",
    "LANG_Self_Device_remote_device": "Remote Device",
    "LANG_fri": "Fri",
    "TabBasicInfo": "The primary information",
    "MdmPolicyControlName_allowCloudBackup": "Allow iCloud backup",
    "Audit_HolidaysService": "Holiday",
    "policyConditionAndItemTitle": "Applied item against policy condition",
    "MdmPolicyControlName_AllowTaskSwitcher": "Allow TaskSwitcher",
    "AddProductDevice": "Add device type",
    "LANG_SETTING_DeviceUserManagement": "User Management",
    "LANG_PositionInfomation": "The location information",
    "LANG_ManageLicense": "License management",
    "LANG_EntryPolicyTargetDesc": "Select a target for Entry MDM Policy.",
    "LANG_nov": "Nov",
    "LANG_LocationPolicyPresentConditionDetail": "Check the LocationPolicy has been applied.",
    "MdmPolicyControlName_MinDevicePasswordComplexCharacters": "Minimum Device Password Complex Characters",
    "jqGrid_alertText": "Please select a row",
    "Configuration_dbmsWarnLimitsize_DESC": "DBMS SERVER set the allowed rate of capacity warning allowed. (Unit:%, default: 85%)",
    "Title_000001500": "녹색성장실장",
    "LANG_ERROR_CSRFFilterError": "Retry needed because of invalud token access.",
    "MdmPolicyControlName_allowPhotoStream": "Allow Photo Stream",
    "ACTION_Login": "Admin login",
    "LANG_LOC_ALERT_addWiFi": "WiFi AP is not exist. First, you must add the WiFi AP.",
    "MESSAGE_ALERT_NOT_BETWEEN_VALUE": "Supported values are {0}, where 0 = 12 AM and 23 = 11 PM.",
    "Title_000001119": "미래기획단장",
    "Title_000001118": "기술연구소장",
    "Title_000001116": "전략경영실장",
    "MdmPolicyControlName_MDMPSP0000000010": "NFC",
    "Title_000001117": "전문위원",
    "Title_000001114": "본부장",
    "Title_000001115": "기술본부장",
    "MdmPolicyControlName_MDMPSP0000000011": "Allow list of WiFi AP",
    "Title_000001112": "선박안전본부장",
    "Title_000001113": "해사안전연구센터장",
    "Title_000001110": "검사본부장",
    "MdmPolicyControlName_periodLocationUpload": "Location information collection period",
    "Title_000001111": "사업본부장",
    "AUDIT_UserService_useVisitor": "useVisitor",
    "PolicyControl_new_category_desc_5000": "Set the policy items for the management of your Windows Phone 10 device.",
    "MdmPolicyControlName_MDMPSP0000000014": "Allow SDCARD replacement",
    "LANG_ERROR_UserIpNotAllowedUserMessage": "Approached from an unauthorized IP. Contact your administrator.",
    "MdmPolicyControlName_MDMPSP0000000013": "Allow USIM replacement",
    "AddUser": "Add an user",
    "LANG_policyTransferTime": "Policy Transfer Time",
    "Title_000001108": "지원본부장",
    "Title_000001107": "경영지원본부장",
    "LANG_VALIDATE_SEARCHID_MESSAGE": "Select the Search ID.",
    "AL_Install_Remove_Log": "Install or delete app",
    "Title_000001109": "안전본부장",
    "Title_000001103": "비상임이사",
    "Title_000001104": "비상임감사",
    "Title_000001105": "감사",
    "Title_000001106": "경영본부장",
    "Title_000001100": "이사장",
    "Title_000001101": "전무이사",
    "Title_000001102": "상임감사",
    "Lang_Policy_HeaderIncluded": "Included",
    "LANG_LocationPolicyApplyList": "ApplyList",
    "ActiveUser": "Active",
    "Configuration_adminAccessIPEnabled": "Access IP Enabled?",
    "ACTION_DeviceService_setDeviceHeartBeat2": "Device heartbeat communication",
    "AUDIT_UserDeviceService_lastPolicyApplied": "lastPolicyApplied",
    "LANG_Today": "Today",
    "LANG_DEVICE_PositionInfomationDetail": "You can check a location of selected device.",
    "AUDIT_DefenceSettingService_createDate": "createDate",
    "deviceLostInfo": "Information about Stolen/lost",
    "LANG_POLICY_conditionConfigDetail": "Set environment for MDM policy practice.",
    "LANG_ExcelExport": "Print by excel",
    "LANG_DEPT_dept": "Dept",
    "LANG_PolicyLocationResourceManagement": "Access Resource Management",
    "PolicyControl_new_category_5000": "Windows Phone",
    "Title_000001134": "혁신팀장",
    "Title_000001135": "기획홍보팀장",
    "Title_000001132": "기술심사부장",
    "BUTTON_ADD": "ADD",
    "Title_000001133": "재정팀장",
    "Title_000001138": "비전기획팀장",
    "Title_000001139": "변화관리자그룹장",
    "Title_000001136": "설계심사팀장",
    "LANG_SETTING_AdminManagement": "Administrator Management",
    "AUDIT_ReservedVisitorService_phoneNumber": "[EN]전화번호",
    "AUDIT_VersionedAppService_appAgent": "appAgent",
    "Title_000001137": "사업기획팀장",
    "LANG_DEVICE_model": "Device model",
    "MESSAGE_ALERT_FAIL_REQUEST": "{0} Your request is failed to process.",
    "Title_000001130": "검사제도부장",
    "Title_000001131": "기술사업부장",
    "RC_SET_STATUS": "Device status settings",
    "Title_000001129": "검사관리부장",
    "LANG_Dept_Not_Same": "Top companies are not subject self.",
    "EditConfiguration": "Change settings",
    "Title_000001121": "기술연구원장",
    "Title_000001122": "단장",
    "Title_000001123": "미래기획부단장",
    "Title_000001124": "경영목표달성을위한T/F팀장",
    "AUDIT_UserDeviceService_imeiVal": "imeiVal",
    "Title_000001125": "중장기발전계획 수립추진 T/F팀장",
    "Title_000001126": "부장",
    "Title_000001127": "경영기획부장",
    "Title_000001128": "총무부장",
    "RoleVisitorAdmin": "Visitor Admin",
    "MdmPolicyControlName_DevicePasswordExpiration": "Device Password Expiration",
    "AL_OfficeAppLog": "Business app's logs",
    "ParentDeptApply": "Apply selected",
    "LANG_ManageGPS": "GPS Management",
    "Title_000001120": "부단장",
    "LANG_RoleUser": "User",
    "LANG_APP_removeTargetInfo": "Remove APP Target Info",
    "AUDIT_BeaconAreaService_updateDate": "updateDate",
    "ISSUE_SOLVE_ERROR_AdminLocked": "User-specified password exceeds the number of failures has been locked. If the \"Admin management\"-putting the lock Fu > \"Admin management\" in the \"unlock\".",
    "ACTION_SystemLocked": "Device is locked by failed password.",
    "Title_000001152": "정보화팀장",
    "ERROR_ReachedMaxSessionCount": "최대허용세션초과",
    "Title_000001151": "전략기획팀장",
    "Title_000001150": "경영혁신팀장",
    "Title_000001159": "연구기획팀장",
    "Title_000001158": "기술연구팀장",
    "Title_000001157": "교육훈련센터",
    "Title_000001156": "해상안전실장",
    "AUDIT_ThirdPartyCompanyService_id": "id",
    "Title_000001155": "선체제도팀장",
    "Title_000001154": "기관제도팀장",
    "parentName": "Top division",
    "LANG_POLICY_CONDITION_TITLE_TYPE_SELECT": "Select Condition",
    "MdmPolicyControlName_ScheduledInstallTime": "Enables the IT admin to schedule the time of the update installation.",
    "AUDIT_UserService_visitorPolicyUrl": "VisitorPolicyURL",
    "MDMx4011": "사용자상태(Status) 정보가 이미 등록되어 있습니다.",
    "MDMx4012": "사용자상태(Status) 정보를 등록하는데 실패하였습니다.",
    "targetId": "Target ID",
    "MDMx4010": "사용자상태(Status) 정보가 없습니다.",
    "Configuration_passwordFailureMax_DESC": "Set a password failure permissible number (default value is 5, scope : 1~5)",
    "LANG_POLICY_add": "Add policy",
    "Title_000001140": "경영예산실장",
    "LANG_TOP_gotoMain": "Main",
    "Title_000001142": "총무인사팀장",
    "Title_000001141": "사업개발팀장",
    "LANG_GPS_Arount_address": "Around",
    "Title_000001148": "총무회계팀장",
    "Title_000001147": "인력개발팀장",
    "Title_000001149": "고객지원팀장",
    "Title_000001144": "검사제도팀장",
    "Title_000001143": "기술지원실장",
    "Title_000001146": "품질인증팀장",
    "LANG_beaconArea_Alert_Empty": "There are no registered beacon proximity.",
    "Title_000001145": "기술사업팀장",
    "PASSWORD_QUALITY_ALPHABETIC": "Characters include",
    "Title_000001800": "국제협력사업추진기획단팀장",
    "LANG_QrCode_Print_Desc": "Print the Qr Code",
    "AUDIT_ThirdPartyDeptService_company": "company",
    "MdmPolicyControlName_EnterpriseProtectedDomainNames": "Enterprise Protected Domain Names",
    "MDMx4020": "등록하려는 ID 는 이미 등록된 사용자(User)가 있습니다.",
    "MDMx4021": "이미 등록된 사용자상태(Status) 정보가 있습니다.",
    "ActivationExpression": "Active expression",
    "MDMx4014": "사용자상태 보조 정보가(SubStatus) 없습니다.",
    "LANG_beaconArea_MODIFY": "Modify Proximity",
    "Title_000001171": "수석행정원",
    "MDMx4013": "사용자상태 보조 정보가(SubStatus) 이미 해지되어 있습니다.",
    "Title_000001170": "연구소기획단장",
    "LANG_OsName": "OS",
    "MDMx4015": "등록된 사용자상태(Status) 정보가 없습니다.",
    "Title_000001175": "부지부장",
    "Title_000001174": "지부장",
    "Title_000001173": "부장직대",
    "Title_000001172": "수석검사원",
    "Title_000001179": "차장",
    "Title_000001178": "실장직대",
    "Title_000001177": "실장",
    "Title_000001176": "출장소장",
    "AUDIT_Pkcs12CertificateService_name": "name",
    "LANG_ExcelExport_Admin": "AdminList",
    "NoticeTargetName": "Target people",
    "IsAllow": "Whether to permit",
    "MdmPolicyControlName_allowSimple": "Allow simple passwords",
    "CompanyName": "Company",
    "Title_000001160": "기술연구실장",
    "Title_000001162": "반장",
    "Title_000001161": "혁신전략실장",
    "Title_000001164": "경영기획실장",
    "LANG_LocationPolicy": "Location",
    "Title_000001163": "정부대행검사실장",
    "Title_000001166": "CI그룹장",
    "AL_registerFail": "Failed to register the handset",
    "Title_000001165": "경영지원실장",
    "LANG_LocationCondition": "Location Condition - CELL ID",
    "Title_000001168": "해양사고방지센터장",
    "MESSAGE_ALERT_NO_SELECT_REMOTE_COMMAND": "Please Select a remote command.",
    "Audit_NoticeService": "News &amp; Info",
    "Title_000001167": "감사실장",
    "Title_000001169": "연구개발부장",
    "BUTTON_CONFIRM": "CONFIRM",
    "Configuration_isCompressDvc": "DVC compression?",
    "LANG_hour14": "14 o'clock",
    "LANG_hour15": "15 o'clock",
    "LANG_hour16": "16 o'clock",
    "MESSAGE_ALERT_SELECT_TARGET_DEVICE": "Please select the target device from the map on the left first.",
    "LANG_hour17": "17 o'clock",
    "PasswordPolicySpecialChar": "Special letters",
    "LANG_hour18": "18 o'clock",
    "LANG_WARNING_LEVEL1_MSG": "[EN]INFO Level : 특정한 이벤트에 대한 로그",
    "LANG_hour19": "19 o'clock",
    "LANG_TotalDeviceC": "Total device(s)",
    "NoticeTargetList": "Notice the target list",
    "LANG_feb": "Feb",
    "LANG_AGENT_LOG_REGISTER_FAILED": "Device registration is failed.",
    "LANG_hour10": "10 o'clock",
    "LANG_hour11": "11 o'clock",
    "LANG_hour12": "12 o'clock",
    "LANG_hour13": "13 o'clock",
    "LANG_ManageProduceDevice": "Device types management",
    "LANG_Hourly": "Hourly",
    "ModifyManageDevice": "Terminal fixes",
    "MdmPolicyControlName_pluginFiles": "MDM Plugin file name",
    "LANG_ManageGlobalCode": "Code management",
    "LANG_Windows_Location02": "Force Location On",
    "Audit_ThirdPartyDeptService": "Department",
    "LANG_Windows_Location00": "Force Location Off",
    "LANG_Windows_Location01": "Location service is allowed",
    "LANG_hour05": "05 o'clock",
    "LANG_LOG_InstallLogDetail": "Check overall status like OS and agent installation status.",
    "LANG_hour06": "06 o'clock",
    "LANG_hour03": "03 o'clock",
    "AL_backupOK": "Backup success",
    "LANG_hour04": "04 o'clock",
    "LANG_hour09": "09 o'clock",
    "LANG_hour07": "07 o'clock",
    "LANG_ManagerDetail": "Detail Administratior",
    "LANG_hour08": "08 o'clock",
    "LANG_PolicyLocationManagement": "Access Management",
    "MdmPolicyControlName_AllowUserToResetPhone": "Allow User To Reset Phone",
    "AUDIT_NoticeTargetService_createDate": "createDate",
    "LANG_hour01": "01 o'clock",
    "LANG_hour02": "02 o'clock",
    "LANG_hour00": "00 o'clock",
    "LANG_LOC_notExistLocaionInfo": "There is no information about device location.",
    "reConnectDeviceMaximumMailBody": "reConnectDeviceMaximum exceeded. Device : {0}, User : {1), Exceeded Count : {2)",
    "LANG_count2": "EA",
    "LANG_DEVICE_TotalStatusDetail": "Check device information, policy, and installed app by department and OS.",
    "LANG_ALT_Statistics": "Device Installation Status.",
    "CUCCommand": "Delete/Install/Update",
    "ERROR_TokenVerification": "Forgery Detected.",
    "Configuration_clientTimeoutSec_DESC": "Set a time limit of device response (default is 600 seconds)",
    "AUDIT_UserService_title": "title",
    "AUDIT_LocationService_userDevice": "userDevice",
    "PasswdSettingRule3": "The password must be combination of  [{0}, {1), {2)].",
    "PasswdSettingRule2": "The password must be combination of  [{0}, {1)].",
    "LANG_jun": "Jun",
    "PasswdSettingRule1": "The password must be set to [{0}].",
    "LANG_jul": "Jul",
    "AUDIT_ReservedVisitorService_email": "[EN]이메일",
    "AL_appKill": "The app shuts down",
    "policyPublish": "Policy distribution",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_SELECT_OUT": "Select Outgoing Beacon Proximity",
    "RC_SYNC_APPS": "App's Policies Synchronization",
    "AUDIT_ControlAPService_id": "id",
    "LANG_duplicate": "Duplicate {0}",
    "LANG_aug": "Aug",
    "LANG_Currentstatus": "Current status",
    "UnlockUser": "Unlock",
    "LANG_Policy_WouldLikeChanege": "Would like to change?",
    "AL_sdmounted": "SD card insert",
    "AL_agentError": "Device internal error",
    "AUDIT_VersionedAppService_hash": "hash",
    "Notification_EmailTitle": "[MDM services security notification] {0}",
    "LANG_NonApplys": "The unapplied",
    "LANG_ManageLatiNotvalid": "The Latitude, longitude is Not valid.",
    "LANG_REMOTE_BACKUP_STATUS": "You have never run the recovery command.",
    "EVERYMONTH": "Every month",
    "LANG_beaconArea_Detail": "Beacon Proximity",
    "LANG_Visisor_Statistics": "Visitor Statistics.",
    "MdmPolicyControlName_allowAssistant": "Allow Siri",
    "LANG_POLICY_CONDITION_TITLE_TYPE_LOCATION_BUTTON_DETAIL": "View Location List",
    "LANG_ManageAddressNotvalid": "The address is not valid.",
    "AUDIT_UserService_lastAccessIp": "lastAccessIp",
    "MdmPolicyControlName_RestrictAppToSystemVolume": "The installation of applications is restricted to the system drive.",
    "LANG_oct": "Oct",
    "LANG_POLICY_callBlockingOn": "Call blocking : ON",
    "LANG_ipPatternis2": "ex) 192.168.0.X",
    "MdmPolicyControlName_allowAppRemoval": "Allow app remove",
    "LANG_ipPatternis1": "IP pattern.",
    "AUDIT_UserDeviceService_lockCnt": "lockCnt",
    "AUDIT_UserService_name": "name",
    "AUDIT_ProductDeviceService_binaryFilePath": "binaryFilePath",
    "Configuration_adminAccessIP2_DESC": "Allow access IP 2 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "DuplicateUsernameEmail": "The user ID or Email is duplicated.",
    "AL_restoreOK": "Recovery success",
    "MdmPolicyControlName_allowGameCenter": "Allow Game Center",
    "LANG_Policy_Filter_check_desc": "If you check the checkbox changes the screen looks right for OS type.",
    "MdmPolicyControlName_forceEnabledMobileData": "Impose using data network",
    "LANG_BeaconAreaArea": "Area Comment",
    "LANG_ManageBeaconAreaDetail": "Manage information of proximity for several beacons.",
    "MdmPolicyControlName_allowCloudKeychainSync": "Allow iCloud Keychain Sync.",
    "Label_LastSyncDate": "Policy application time",
    "LANG_apr": "Apr",
    "LANG_iPhone": "iPhone",
    "HHI_ERROR_AuthenticationFailed": "ID,PW AuthenticationFailed",
    "LANG_AuditEntityName": "Object",
    "LANG_hour23": "23 o'clock",
    "WhiteAppAppointmentTrue": "Designation",
    "LANG_hour22": "22 o'clock",
    "LANG_hour21": "21 o'clock",
    "LANG_POLICY_APPLICATION_FAILED": "Policy failure.",
    "LANG_hour20": "20 o'clock",
    "MdmPolicyControlName_MDMPSP0000000007": "USB tethering",
    "MdmPolicyControlName_MDMPSP0000000008": "Allow USB storage",
    "MdmPolicyControlName_MDMPSP0000000009": "Allow USB debugging",
    "Configuration_passwordMaxLength_ALERT": "{0} : the value must be at 16, please specify.",
    "searcher": "Searcher",
    "LANG_POLICY_LOCATION": "Location Policy",
    "Configuration_deviceMaximumInactiveTime_ALERT": "{0} : the value must be between 240 to 8760, please specify.",
    "AUDIT_NoticeService_createDate": "createDate",
    "RegisterVersion": "Registered Ver.",
    "LANG_Policy_ChooseTarget": "Please choose in the deleted target.",
    "LANG_AddHoliday": "Add holiday",
    "MdmPolicyControlName_allowVoiceDialing": "Allow voice dialing",
    "RoleSuperManager": "The super manager",
    "LANG_apr2": "April",
    "LANG_Daily": "Daily",
    "AUDIT_UserService_customUserType": "customUserType",
    "EVERYDAY": "Every day",
    "AUDIT_ThirdPartyDeptService_name": "name",
    "LANG_AGENT_LOG_REGISTER_SUCCEEDED": "Device registration is successful.",
    "AUDIT_ReservedVisitorService_name": "[EN]이름",
    "SENT": "Transmission completed",
    "LANG_LostWeekly": "Lost this week",
    "LANG_AccessInPolicy": "Access Policy In Setting",
    "MESSAGE_ALERT_NOT_ALLOWED_GET_LOCATION": "You can't get device location information because of user's configuration.",
    "LANG_plzSelectCom": "Please select company.",
    "Password": "Password",
    "LANG_Self_Desc_warning_to_desc": "warning",
    "TermCount": "Count",
    "AUDIT_UserService_lastAccessTime": "lastAccessTime",
    "AUDIT_PassingStatusService_name": "name",
    "AUDIT_UserService_credential": "credential",
    "LANG_Self_Device_info": "Register device",
    "LANG_msgInsert": "insert",
    "LANG_WelcomeLogin": "logged in succesfully",
    "LANG_Self_Device_connect_status": "Connect status",
    "MdmPolicyControlName_maxInactivity": "Max device lock time (Min.)",
    "AUDIT_VisitorUserService_employeeCompany": "employeeCompany",
    "MdmPolicyControlName_allowScreenShot": "Allow ScreenShot",
    "MESSAGE_ALERT_CONFIRM_MODIFY": "Do you want to modify?",
    "AL_common": "General log",
    "MdmPolicyControlName_PWPOLICY00000001": "Password use",
    "PolicyControl_category_00006": "Device Control",
    "PolicyControl_category_00005": "WiFi & Network Control",
    "PolicyControl_category_00008": "Device Communication",
    "PolicyControl_category_00007": "Display",
    "Configuration_passwordFailureMax": "Password failure number",
    "PolicyControl_category_00009": "App Security",
    "LANG_policyTransfer_Failed": "Policy transfer failed.",
    "MdmPolicyControlName_AllowDeveloperTools": "Can use F12 Developer Tools.",
    "PolicyControl_category_00002": "Agent Management",
    "PolicyControl_category_00001": "Log Setting",
    "PolicyControl_category_00004": "Backup Reserved",
    "PolicyControl_category_00003": "Device Auth",
    "AL_SamsungSDK": "Samsung SDK disabled",
    "AUDIT_AppService_agentDeviceVendor": "agentDeviceVendor",
    "ISSUE_SOLVE_DeviceIsNotSupported": "Unsupported device model {0} are you sure you want to use to activate?",
    "LANG_NUMERIC_CHECK": "The [{0}] is numeric characters only.",
    "LANG_REMOTE_RECEIVE_PHONENUM": "Transmitting number",
    "Audit_ThirdPartyCompanyService": "Company",
    "PolicyControl_category_00011": "Safari",
    "PolicyControl_category_00010": "Accessibility",
    "LANG_ModelName": "Model",
    "CertificateType": "Type of certificate",
    "PolicyControl_category_00014": "Profile Security",
    "PolicyControl_category_00013": "Password Setting",
    "PolicyControl_category_00012": "Password Policy",
    "LANG_AP_MODIFY": "Modify AP(Access Point)",
    "LANG_POLICY_notSelectedTarget": "Target is not selected.",
    "LANG_SuccessToSave": "Success To Save.",
    "AUDIT_UserDeviceService_lastSyncTime": "lastSyncTime",
    "LANG_AccessInPolicyDesc": "Access Policy In Setting",
    "Configuration_passwordMinLength": "Minimum length of password",
    "handleIssue": "Processing",
    "AUDIT_UserTitleService_name": "name",
    "RC_APP_RUN": "Run your app",
    "AL_AOMErr": "AOM push registration failed",
    "LoginSessionExpired": "Login session has been terminated. Please log in again.",
    "AUDIT_VisitorUserService_email": "email",
    "AlertSelectTarget": "Select the target.",
    "LANG_DEVICE_fistSelectDeviceLeftmap": "Select target device on the list left first.",
    "LANG_plzSelectParamO": "Please select {0}",
    "MdmPolicyControlName_CellularAppDownloadMBLimit": "Cellular App Download Limit (MB)",
    "AuditDifference": "Change data",
    "RC_ERROR_ON_SENDING": "Failed to send the command",
    "LANG_plzSelectParamR": "Please select {0}",
    "ACTION_DeviceMDMService_getMdmCommands": "The remote command is received and communication devices",
    "LANG_PropertyValueModify": "Modify setting value",
    "LANG_APP_WhiteAppManagementShort": "White app",
    "ErrorMessage": "Error",
    "AUDIT_VersionedAppService_appType": "appType",
    "LANG_ManagerName": "Admin name",
    "LANG_sourceDevice": "Target device",
    "BUTTON_CLOSE": "CLOSE",
    "Configuration_licenseCode": "MDM License Code",
    "MdmPolicyControlName_allowCloudDocumentSync": "Allow iCloud Doc. Sync.",
    "TargetDept": "Department",
    "LANG_SMS_COMPLETE": "SMS SEND COMPLETE",
    "MdmPolicyControlName_allowGlobalBackgroundFetchWhenRoaming": "Allow auto sync when romming",
    "ACTION_DBLimitWarning": "Storage Warning Limit",
    "deviceAppInfo": "App information",
    "AUDIT_ReservedVisitorService_visitorDeptName": "[EN]방문부서",
    "AUDIT_NoticeService_updateDate": "updateDate",
    "AL_ProfileCreateToNormal": "Agent Profile Register",
    "ERROR_DBLimitWarning": "Storage Warning limit exceed.",
    "LANG_NOTICE_Latest": "Recent notice",
    "LANG_LOG_LogManagement": "Log",
    "LANG_Android": "Android",
    "BUTTON_CANCLE": "CANCLE",
    "execResult": "Execution result",
    "LANG_POLICY_CONDITION_LOCATION": "Location",
    "AjaxCommunicationError": "Please try again error Ajax communication.  n.",
    "BUTTON_TERMINATE": "TERMINATE",
    "LANG_LOC_latitude": "Latitude",
    "java.lang.Exception": "{0}",
    "LANG_POLICY": "Policy",
    "LANG_ManageCompany": "Supplier management",
    "LANG_SMS_NotUsed": "Do not use the SMS transmission function .",
    "AUDIT_UserService_passwordConfirm": "passwordConfirm",
    "LANG_Windows_Password_Character03": "Digits, lowercase,uppercase, special characters",
    "manager": "Manager",
    "LANG_APP_publishInfo": "Information of distributed APP",
    "LANG_Windows_Password_Character02": "Digits, lowercase uppercase",
    "LANG_Windows_Password_Character01": "Digits and lowercase",
    "AUDIT_UserService_iosDownLoadUrl": "IOSDownloadURL",
    "LANG_Windows_Password_Character00": "Digits only",
    "LANG_searchDate": "search period",
    "ERROR_UserLocked": "User specified password has been locked by {0} failed.",
    "LANG_ALT_policyManagement": "Manage policy for MDM control.",
    "LANG_CreateDate": "Date",
    "SETTING_CATEGORY_1": "Security basic setting information",
    "AUDIT_UserService_windowsMDMUse": "WindowsMDMUSe",
    "LANG_policyTransfer_ING": "Of transport policy.",
    "LANG_WP_federated_enrollment_ERROR_UserLocked": "Locked user. Please ask to your system administrator.",
    "APPCONTROLBLACK": "black app",
    "LANG_LastestSendDate": "Lastest Sync Devices",
    "AL_appInstall": "App installation",
    "Configuration_adminAccessIP3_DESC": "Allow access IP 3 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "ALERT_TO_GPS_POINT": "The value of the GPS position must be at least 4 Point",
    "LANG_ExcelExport_UserDeviceSum": "SumDevice",
    "LANG_REMOTE_LOST_ING_REPORT_MESSAGE": "Lost / Stolen report progressing.",
    "RC_RM": "Delete critical information",
    "LANG_POLICY_Publish": "Distribute policy",
    "SecurityIssueAlert_Title": "Addresses the security issues",
    "ERROR_DeviceRegistrationCnt": "It exceeded the maximum number of terminals installed",
    "SECEND15": "15 sec",
    "SETTING_CATEGORY_2": "Administrator setting information",
    "SETTING_CATEGORY_3": "Device setting information",
    "SETTING_CATEGORY_4": "Password policies",
    "ERROR_insertReservedVisitor": "Reservations visitor registration failure.",
    "LANG_APP_AppManagementDetail": "Office app (work-related app) and App management related function.",
    "LANG_aug2": "August",
    "MdmPolicyControlName_RequireProtectionUnderLockConfig": "Require Protection Under Lock Config",
    "LANG_sat": "Sat",
    "AUDIT_UserDeviceService_mobileNumber": "mobileNumber",
    "LANG_DeviceRemoteManage": "Remote management",
    "LANG_CompanyName": "Company",
    "LANG_EXECUTION_FAILED": "Push execution is failed(server error).",
    "MdmPolicyControlName_AllowWiFiHotSpotReporting": "Allow WiFi HotSpot Reporting",
    "LANG_LOC_cellid": "Cell ID",
    "LANG_WP_federated_enrollment_ERROR_DeviceIsNotActivatedForUse": "Device type must be activated before user enrolling. Please ask to your system administrator.",
    "ISSUE_SOLVE_GUIDE_Title_DeviceManagerDisabled": "MDM Device Manager enrollment information",
    "LANG_msgDelete": "delete",
    "LANG_APlist": "Wireless AP list",
    "AUDIT_UserDeviceService_heartbeatDateTime": "heartbeatDateTime",
    "AL_LocationInfoFail": "Failed to get device location information.",
    "MdmPolicyControlName_minComplexChars": "Minimum composite characters",
    "AUDIT_VersionedAppService_certificate": "certificate",
    "DeviceResource_2004": "Battery Status",
    "DeviceResource_2003": "Available Memory",
    "DeviceResource_2006": "Available External Storage",
    "MdmPolicyControlName_EnterpriseModeSiteList": "Allows the user to specify an URL of an enterprise site list.",
    "DeviceResource_2005": "Total External Storage",
    "LANG_Platform": "OS",
    "DeviceResource_2002": "Total Memory",
    "codeValue": "Code value",
    "DeviceResource_2001": "CPU Usage",
    "AUDIT_VersionedAppService_installedAppVersion": "installedAppVersion",
    "SAFARIACCEPTCOOKIES_ALLWAYS": "Always",
    "MdmPolicyControlName_muteMic": "Block voice recording",
    "PASSWORD_QUALITY_UNSPECIFIED": "No constraints",
    "AlertMailSubject": "[Warning]Forgery app is detected.",
    "MdmPolicyControlName_AllowActionCenterNotifications": "Allow ActionCenter Notifications",
    "MESSAGE_ALERT_CERTIFICATES_FILEEXT_CHECK": "This extension of the files can not be uploaded.",
    "MdmPolicyControlName_sendPeriodFatalLog": "Critical log upload period",
    "IsPushEnable": "Remote communications",
    "LANG_RetainSession": "Automatically maintain session",
    "LANG_Inquirer": "Inquirer",
    "LANG_APP_Use_PresentCondition": "App Use",
    "LANG_Self_Device_find_location": "Find location",
    "LANG_CONFIRM_TO_Delete": "Are you sure object to delete?",
    "BUTTON_UPDATE": "UPDATE",
    "LANG_mon": "Mon",
    "WhiteAppAppointmentFalse": "Clear the designation",
    "AUDIT_VersionedAppService_installedDate": "installedDate",
    "AddHoliday": "Add holidays",
    "AL_AppsInfoFail": "Failed to get device app install information.",
    "LANG_Self_Device_find_location_desc": "You can check the current location of a lost device.",
    "LANG_UploadAppFile": "Upload file",
    "LANG_NOTICE_Send2": "Send",
    "respAdmin": "Responsible manager",
    "AUDIT_UserDeviceService_statusCode": "statusCode",
    "ACTION_SamsungSDK": "Samsung SDK was disabled.",
    "AUDIT_VisitorUserService_complete": "complete",
    "LANG_PackageId": "Package ID",
    "MdmPolicyControlName_allowAssistantWhileLocked": "Allow Siri while locked",
    "DeviceResource_2008": "Available Internal Storage",
    "DeviceResource_2007": "Total Internal Storage",
    "LANG_sep": "Sep",
    "LANG_SETTING_SystemSettings": "System Configuration",
    "AUDIT_DefenceSettingService_propertyValue": "propertyValue",
    "AUDIT_VisitorUserService_employeePosition": "employeePosition",
    "AUDIT_UserService_accountNonLocked": "accountNonLocked",
    "ERROR_DeviceInactiveMaximumTime": "The device has no access record for longer than appointed time.",
    "MdmPolicyControlName_allowYouTube": "Allow YouTube",
    "AUDIT_VisitorUserService_createDate": "createDate",
    "EditSecurityIssue": "Security issues fixed",
    "LANG_ExcelExport_User": "UserList",
    "RoleVisitorManager": "Visitor Manager",
    "RC_POLICY_ON": "Device Policy ON",
    "AUDIT_UserDeviceService_nowPolicyControl": "nowPolicyControl",
    "MdmPolicyControlName_AllowSearchSuggestionsinAddressBar": "Search suggestions are allowed in the address bar.",
    "LANG_LastAccessIp": "IP",
    "LANG_severity": "Severity",
    "TabVerificationLogs": "Validation log",
    "RC_RESTORE": "Recovery",
    "BUTTON_DEL": "DEL",
    "LANG_App_Upload_WhiteApp_is_Exists": "White App is already exists.",
    "AUDIT_UserDeviceService_name": "name",
    "DeviceUser": "User",
    "AUDIT_HolidaysService_holidayDesc": "holidayDesc",
    "ModifyUser": "Modify user",
    "LANG_POLICY_CONDITION_TIME": "Time",
    "MdmPolicyControlName_AllowSimpleDevicePassword": "Allow Simple Device Password",
    "LANG_APP_OfficeAppManagement": "Office app management",
    "AUDIT_NoticeService_id": "id",
    "LANG_WP_federated_enrollment_ERROR_AuthenticationFailed": "User authentication failed. Please check your id or password for your email address.",
    "AL_registerOK": "Handset registration is complete",
    "DuplHolidayError": "There are designated holidays.",
    "LANG_CONFIRM_TO_Apply": "Do you want to apply?",
    "LANG_SecurityManagement": "Security management",
    "MdmPolicyControlName_allowSaveLogInternal": "Save log to internal storage",
    "controlItemValue": "Setting",
    "LANG_execResult": "Results",
    "LANG_AccessOutPolicy": "Access Policy Out Setting",
    "LANG_POLICY_CONDITION_WIFI": "WiFi-AP",
    "LANG_APP_NoneAppManagement": "Other app management",
    "LANG_POLICY_PolicyResources": "Policy Resource",
    "ERROR_DEPTDEL_EXIST_SUB": "There is a sub dept or a user can not be deleted.",
    "Title_000001400": "사무원",
    "LANG_noRecord": "No records to view",
    "CertificateAlias": "Alias",
    "LANG_LOG_IssueLog": "Security Issue Log",
    "LANG_DEVICE_PositionInfomation": "Location Information",
    "LANG_Applys": "applied",
    "LANG_APP_WhiteAppAdd": "Add white app",
    "AppName": "App",
    "RC_APP_STOP": "Shut down app",
    "LANG_REMOTE_LOST_NOT_REPORT_MESSAGE": "Lost / Stolen is not reported.",
    "MdmPolicyControlName_AllowAppStoreAutoUpdate": "automatic update of apps from Windows Store are allowed.",
    "MdmPolicyControlName_MaxInactivityTimeDeviceLock": "Max Inactivity Time Device Lock",
    "ACTION_DeviceService_isHoliday": "Holiday Check",
    "LANG_APP_CompanyName": "Company",
    "PackageName": "Package name",
    "LANG_Windows_Password_Required01": "Numeric PIN or password required.",
    "AUDIT_ThirdPartyDeptService_createDate": "createDate",
    "Lang_DeviceSumOther": "Other",
    "LANG_Windows_Password_Required00": "Alphanumeric PIN or password required.",
    "PolicyControl_new_category_desc_6000": "Set the policy items for the management of your Windows OS 10 device.",
    "Title_000001000": "PM",
    "ALLOW_TELEMETRY_ALLOWED": "Allowed",
    "LANG_Windows_Password_Required02": "Users can choos.",
    "LANG_logMessage2": "Message",
    "Title_000001001": "PL",
    "Title_Clerk": "Clerk",
    "PolicyControl_new_category_3001": "Device Control",
    "PolicyControl_new_category_3002": "App Aplication",
    "MdmPolicyControlName_sendErrorLog": "Error log transmission status",
    "PolicyControl_new_category_3003": "iCloude Control",
    "PolicyControl_new_category_3004": "Safari Control",
    "PolicyControl_new_category_3000": "General",
    "LANG_modifyWhiteApp": "Modify white app",
    "LANG_AuditOperation": "Audit operation",
    "LANG_TOP_StatisticsLog": "Statistics",
    "LANG_LOG_LostManagement": "Lost/Stolen Status",
    "Operation_CREATE": "Generation Complete",
    "AL_UsbStorage": "USB Storage",
    "LANG_LocationPolicyNonApplys": "Unapplied",
    "LANG_POLICY_list": "Policy Item",
    "LANG_DEVICE_TotalInfoDetail": "If you click the tree map on the left, you can see the device information.",
    "LANG_SESSION_TIMEOUT": "Admin User Session Timeout",
    "PolicyControl_new_category_3005": "Policy the Password",
    "LANG_REMOTE_LOST_NOT_ING_REPORT_MESSAGE": "Found report progressing.",
    "AUDIT_BeaconAreaService_name": "name",
    "LANG_Policy_NoSelectedPolicy": "There is no selected policy.",
    "ALLLOG": "Send entire log",
    "AUDIT_ThirdPartyDeptService_updateDate": "updateDate",
    "Audit_NoticeTargetService": "Notice the target",
    "LANG_SETTING_DeviceTypeManagement": "DeviceType Management",
    "LANG_LOC_description": "Description",
    "AUDIT_VersionedAppService_versionName": "versionName",
    "AUDIT_UserDeviceService_lastVersion": "lastVersion",
    "AUDIT_UserService_membernum": "membernum",
    "LANG_AdminLockedUserMessage": "The ID is locked. Contact administrator for more information.",
    "LANG_POLICY_PolicyConfig": "Policy Configuration",
    "Audit_UserService": "User",
    "logDateTime": "Inquiry date",
    "AuditEntityOriginal": "Source data",
    "LANG_NOTICE_ValidateDate_ALERT": "You can specify a end date before the start date.",
    "LANG_INITPW_ITEM_SEND": "Send",
    "LANG_SelectDeviceDetail": "Select target device on the list left",
    "LANG_WP_federated_enrollment_item_user_id": "User ID",
    "AUDIT_VersionedAppService_agentDeviceVendor": "agentDeviceVendor",
    "codeDesc": "Description",
    "MdmPolicyControlName_AllowManualMDMUnenrollment": "Allow Manual MDM Unenrollment",
    "LANG_parentName": "Parent department",
    "LANG_IsLost": "Lost",
    "AL_policyApplyOK": "Policy enforcement succeeded",
    "MdmPolicyControlName_MDMWNS0000000005": "WiFi Hotspot",
    "LANG_LoginID": "ID",
    "MdmPolicyControlName_MDMWNS0000000004": "VPN",
    "MdmPolicyControlName_MDMWNS0000000003": "Bluetooth/Bluetooth tethering",
    "LANG_HolidayList": "Holiday list",
    "MdmPolicyControlName_MDMWNS0000000002": "3G/4G",
    "Configuration_adminAccessIP_ALERT": "{0} : Invalid IP.",
    "MdmPolicyControlName_MDMWNS0000000001": "WiFi/WiFi Direct",
    "MdmPolicyControlName_pinHistory": "Number of saved password",
    "policyPublishNoTarget": "No Targets",
    "Version": "Version",
    "deviceLostMsg": "Message",
    "LANG_APP_BlackAppAdd": "Add black app",
    "LANG_APP_publish": "Distribution of APP",
    "ACTION_DeviceService_registerDevice": "Mobile information device attempted registration:",
    "LANG_USR_AddUser": "User",
    "MdmPolicyControlName_maxFailedAttempts": "Password attempts limit",
    "AUDIT_UserDeviceService_unlockToken": "unlockToken",
    "LANG_APP_deselect": "Release",
    "LANG_POLICY_COMMENT_SelectCondition": "Select the policy condition you want to set",
    "Configuration_dbmsCriticalLimitsize": "Permitted capacity excessing allowed DBMS SERVER rate setting",
    "Configuration_passwordChangePeriod_ALERT": "{0} : the value must be between 3 to 5, please specify.",
    "AUDIT_PassingStatusService_id": "ID",
    "MdmPolicyControlName_useTimeOutFeatureOfTheScreen": "Use screen time limit function",
    "APPCONTROLNONE": "off",
    "LANG_SMS_RESEND": "SMS RESEND COMPLETE",
    "LANG_LOGIN_PASSWORD_CHANGE_MESSAGE2": "Please change the password within {0} days.",
    "LANG_LOGIN_PASSWORD_CHANGE_MESSAGE1": "{0} days gone by when you change the password.",
    "NoticeStartDate": "Start date",
    "LANG_PERSONNEL_ReservedVisitorManagementLatest": "latest to Reserved Visitor.",
    "AUDIT_NoticeService_content": "content",
    "LANG_CATEGORY_STATISTICS": "Statistics",
    "LANG_REMOTE_LOST_FOUND_MSG": "Lost/Stolen Released.",
    "LANG_LogDate": "Creation time",
    "LANG_APP_publishInfoDetail": "Detail information of app you want to deploy.",
    "LANG_IsNotLostIng": "Found Progress",
    "MdmPolicyControlName_AllowUSBConnection": "Allow USB Connection",
    "LANG_APP_WhiteAppState": "White app status",
    "LANG_PolicyLogAppRemo": "Policy/Log/App/Remote",
    "LANG_ALT_DeviceCondition": "Device Status.",
    "MdmPolicyControlName_AllowLocation": "Allow Location",
    "NoticeNewsTarget": "Notice the target selection",
    "PASSWORD_QUALITY_COMPLEX": "Contains special characters",
    "LANG_POLICY_PolicyConfigPassing": "Policy Config to Access",
    "LANG_Condition": "Condition",
    "AUDIT_ReservedVisitorService_isVisiting": "[EN]방문자방문여부",
    "LANG_isRequired": "{0} is required.",
    "LANG_targetName": "Target name",
    "LANG_POLICY_PolicyConfigDetail": "Check policy applicable state by policy and group",
    "AUDIT_ControlAPService_apDesc": "apDesc",
    "ALWAYSON": "Always on",
    "LANG_plzSelctOneRow": "Only one target can be selected.",
    "AUDIT_AppService_category": "App Category",
    "MdmPolicyControlName_AllowVoiceRecording": "Allow Voice Recording",
    "LANG_ALT_noticeManagement": "Manage notification for the device user",
    "AddManageDevice": "Add device",
    "CompanyEditPopup": "Modify company",
    "LANG_INITPW_REQUIRE_PASSWORD": "Input your new password.",
    "LANG_Validation_alert_beginDate_fail": "Please makesure that the searching start date is befor the ending date.",
    "LANG_TABLE_TO_NO_LIST": "No List To Data",
    "LANG_PolicyOut": "OUT Policy",
    "LANG_DEVICE_BaseInfo": "Basic Information",
    "LANG_row": "item",
    "AddNotice": "Add notice",
    "MdmPolicyControlName_LocalDeviceName": "Sets the local Bluetooth device name.",
    "LANG_feb2": "February",
    "MdmPolicyControlName_AlphanumericDevicePasswordRequired": "Alphanumeric Device Password Required",
    "AL_LocationInfoOK": "The location information of the device was successfully retrieved.",
    "AL_Rooting": "Device OS rooting",
    "Status_CLOSED": "Completed",
    "AUDIT_Pkcs12CertificateService_isTerminated": "isTerminated",
    "RC_GET_LOCATION": "Device location",
    "LANG_POLICY_PolicyResourcesDetail": "Manage information about MDM policy performed location.",
    "FINISHED": "Mobile complete execution",
    "LostIsLock": "Lock-in-running",
    "PolicyControl_new_category_4002": "Location Information",
    "WLAN_SCANMODE_NORMAL": "Normal",
    "LANG_POLICY_InvokedTargetList": "Policy Applied Target List",
    "PolicyControl_new_category_4001": "Agent Management",
    "PolicyControl_new_category_4000": "Log Management",
    "MdmPolicyControlName_AllowWindowsTips": "Enables or disables Windows Tips / soft landing",
    "LANG_jul2": "July",
    "LANG_LOC_remoteCommandList": "Remote Command History",
    "LANG_WP_federated_enrollment_ERROR_DeviceIsNotSupported": "Unsupported device type. Please ask to your system administrator.",
    "LANG_ManagerConfigDetail": "Set the administrator for MDM management page.",
    "LANG_policyTransfer_Complete": "Policy transfer is complete.",
    "LANG_UserLockedUserMessage": "The ID is locked. Contact administrator for more information.",
    "LANG_REMOTE_LOST": "Do you want your device lost or stolen?",
    "CertIsTerminated": "Terminated",
    "ISSUE_SOLVE_ERROR_DeviceIsNotSupported": "For unsupported device model, you can activate the device model using device type management.",
    "MDMx0000": "Success",
    "LANG_STAND_BY": "Push execution is stand by.",
    "sourceType": "Log source",
    "LANG_sourceUser": "Target user",
    "AUDIT_UserDeviceService_moduleInstalled": "moduleInstalled",
    "LANG_Security_Issue": "Security Issue",
    "LANG_DetailDesc": "Detail Infomation",
    "AUDIT_ThirdPartyDeptService_extCode": "extCode",
    "SourceType_USER_ACTION": "User",
    "MdmPolicyControlName_passwordQuality": "Password type",
    "PasswordConfirmError": "Password and confirm password values are different.",
    "RoleType": "User rating",
    "LANG_jun2": "June",
    "PolicyControl_new_category_desc_2003": "Set the app running, control, policy management for deletion.",
    "MESSAGE_ALERT_SUCCESS_REQUEST": "{0} Your request is processed succesfully.",
    "PolicyControl_new_category_desc_2002": "Set policies to control network unit on your device.",
    "PolicyControl_new_category_desc_2004": "Set the scheduled backup management policies.",
    "ERROR_ON_EXECUTING": "Execution failed",
    "jqGrid_refresh": "Refresh",
    "Audit_UserDeviceService": "Terminal",
    "LANG_Policy_Not_Delete": "Default policy not delete.",
    "policyCondition": "Policy conditions",
    "Configuration_sessionMaxInactiveInterval": "Automatic termination of session time limit",
    "AUDIT_UserDeviceService_commonPolicyVer": "commonPolicyVer",
    "ProductDeviceImage": "Device Image",
    "LANG_APP_remove": "Remove APP in device",
    "NoticeContent": "Contents of notice",
    "AUDIT_ThirdPartyCompanyService_updateDate": "updateDate",
    "LANG_REMOTE_LOST_SEND_MSG": "Lost/Stolen Reported.",
    "MdmPolicyControlName_allowAddingGameCenterFriends": "Allow to add Game Center friends",
    "LANG_ExcelExport_OfficeAppInstall": "OfficeAppInstallList",
    "ModifyDept": "Modify department",
    "LANG_BeaconProximityUUID": "ProximityUUID",
    "LANG_POLICY_PolicyApplyStatusDetail": "Policy enforcement status by organization-specific views.",
    "LANG_PolicyInternal": "INTERNAL Policy",
    "jqGrid_edit": "Edit",
    "LANG_PolicyDesc": "Policy Description",
    "logResult": "Result",
    "LANG_wen": "Wed",
    "AUDIT_ReservedVisitorService_employeeName": "[EN]담당자",
    "LANG_plzSelectComDept": "Please select company or department.",
    "MdmPolicyControlName_AllowToasts": "Allow toast notifications above the device lock screen.",
    "AUDIT_BeaconAreaService_proximityUUID": "proximityUUID",
    "LANG_BeaconConditionDesc": "Set the policy conditions of  Beacon device based.",
    "LANG_APP_CertAppManagement": "certificate management",
    "ADPR_AN": "AlphaNumeric",
    "LANG_Already_registered_officeApp": "Already registered in Office App.",
    "backupMng": "Backup management",
    "InvalidEmail": "Email is not valid.",
    "LANG_Policy_all_btn_desc": "The full on / off button on the applicability.",
    "Configuration_deviceRegistrationCnt": "Limit the number of devices installed",
    "MESSAGE_ALERT_CONFIRM_RELEASE": "Do you want to release?",
    "NoticeTargetListDetail": "Notice to be delivered to the end user applies to the management.",
    "LANG_New_Users": "New Users",
    "LANG_Self_Device_restore_device": "Restore Device",
    "MdmPolicyControlName_allowUnknownSources": "Allow Unknown sources",
    "Audit_LocationService": "Location",
    "LANG_EXECUTION_IGNORED": "Push execution is ignored.",
    "MESSAGE_ALERT_CONFIRM_FAIL_INIT": "Initialization failed",
    "ChangeDept": "Change",
    "LANG_INITPW_ITEM_PASSWORD": "New Password",
    "LANG_Policy_TargetIsOneMoreThan": "At least one Policy Target Select to.",
    "LANG_LOG_AuditLogDetail": "Check a audit log about MDM administrator.",
    "LANG_POLICY_APPLICATION_WAIT": "Awating application policy.",
    "AUDIT_VisitorUserService_employeeName": "employeeName",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BIZ_APP_SELECT": "Select Biz APP",
    "AUDIT_UserService_id": "id",
    "AUDIT_Pkcs12CertificateService_createDate": "createDate",
    "LANG_Officer": "Officer",
    "RC_LOST": "Report of loss",
    "orderNo": "Order",
    "WillNotSelectYourself": "You cannot select yourself for the parent Department.",
    "MdmPolicyControlName_pushSsl": "Own push SSL status",
    "PolicyControl_new_category_desc_2000": "Set the password policy for the security of the device.",
    "LANG_total": "Total",
    "PolicyControl_new_category_desc_2001": "Sets the policy for controlling the devices.",
    "Configuration_adminAccessIP2": "Access IP 2",
    "Configuration_adminAccessIP1": "Access IP 1",
    "HolidayDesc": "Description",
    "LANG_ERROR_UserSessionTimeoutUserMessage": "Admin Timeout",
    "Configuration_adminAccessIP4": "Access IP 4",
    "Configuration_adminAccessIP3": "Access IP 3",
    "AUDIT_LocationService_updateDate": "updateDate",
    "AUDIT_UserService_passwordChangeDate": "passwordChangeDate",
    "ACTION_SessionTimeout": "Admin Timeout",
    "SubjectDn": "Subject DN",
    "AUDIT_UserDeviceService_registedDevice": "REGISTED DEVICE",
    "LANG_Position": "Position",
    "RC_FINISHED": "The command execution completed",
    "LogOut": "Logout",
    "LANG_ManageDevice": "Device Management",
    "Configuration_deviceMaximumInactiveTime_DESC": "Set a time limit of disconnection between a device and server( default is 720 Min.)",
    "AUDIT_Pkcs12CertificateService_updateDate": "updateDate",
    "LANG_dec": "Dec",
    "LANG_GPSConditionDesc": "Set the policy conditions of GPS based.",
    "LANG_APP_selected": "Assign",
    "LANG_plzInsertParamR": "Please insert {0}",
    "LANG_POLICY_CONDITION_SETTING_VALUE": "Setting Value",
    "LANG_plzInsertParamO": "Please insert {0}",
    "reConnectDeviceMaximumMailSubject": "[Warning] reConnectDeviceMaximum exceeded.",
    "LANG_SubTotalSum": "SubTotal",
    "LANG_AppVerificationLogs": "App verification log",
    "conditionValue": "Condition codes",
    "LANG_POLICY_PolicySchedule": "Schedule a policy transfer",
    "ALLOW_LOCATION_NOT": "NotAllowed",
    "AUDIT_VersionedAppService_tag": "Tag",
    "AUDIT_BeaconAreaService_major": "minor",
    "LANG_may2": "May",
    "MdmPolicyControlName_AllowPopups": "Pop-up browser windows are allowed.",
    "AUDIT_UserService_createDate": "createDate",
    "MdmPolicyControlName_AllowNFC": "Allow NFC",
    "LANG_LOG_InstallLogList": "List of installation status",
    "ERROR_DeviceInfomationIsNotProvided": "Is an invalid authentication request information.",
    "PasswdLengthRule": "The password length is [{0} to {1)] characters.",
    "LANG_APP_OfficeAppAdd": "Add office app",
    "ERROR_10001": "10001",
    "LANG_LOG_DeviceLogDetail": "Check a principal log.",
    "ERROR_10003": "10003",
    "ERROR_10002": "10002",
    "ERROR_10005": "10005",
    "ERROR_10004": "10004",
    "LANG_Policy_select_un_all": "Deselect all",
    "BUTTON_REMOVE": "REMOVE",
    "RC_RECEIVED": "Receiving",
    "AUDIT_VersionedAppService_plistFilePath": "plistFilePath",
    "ALLOW_LOCATION_ALLOWED": "Allowed",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BIZ_APP_BUTTON_DETAIL": "View Biz APP List",
    "LANG_dayofweeks": "{0}day",
    "Configuration_isCompressDvc_DESC": "To verify forgery app, set a compression status of dynamic verification code",
    "ERROR_10008": "10008",
    "ERROR_10009": "10009",
    "ERROR_10006": "10006",
    "ERROR_10007": "10007",
    "unknownDevice": "The unknown device",
    "ACTION_DBLimitCritical": "Storage Critical Limit",
    "LANG_Policy_Priorities": "Priorities",
    "ERROR_10010": "10011",
    "LANG_changeDeptTitle": "Select the parent Department",
    "LANG_Visitor": "Visitor",
    "MdmPolicyControlName_AllowCortanaAboveLock": "User can interact with Cortana using speech while the system is locked.",
    "ERROR_LDCC_http_not_ok": "\"LDCC Server connection fails\" or \"is not registered phone number\".",
    "InstallVersion": "Installed Ver.",
    "AUDIT_ControlAPService_name": "name",
    "LANG_LogIn": "Login",
    "LANG_Group": "Group",
    "BUTTON_INSTALL": "INSTALL",
    "LANG_WP_federated_enrollment_user_auth_ok_message": "User verified successfully and follow Next Step.",
    "LANG_TOP_Settings": "Configuration",
    "AUDIT_NoticeService_name": "name",
    "AUDIT_ReservedVisitorService_externalVisitNo": "[EN]방문자번호",
    "AUDIT_ThirdPartyDeptService_statusCode": "statusCode",
    "MdmPolicyControlName_forceEnabledBluetooth": "Impose using bluetooth",
    "RESULT_OK": "Success",
    "CertificateFile": "Certificate file",
    "MdmPolicyControlName_allowLocationUpload": "Collect location information",
    "Configuration_systemEmail_ALERT": "{0} : Invalid email address.",
    "MdmPolicyControlName_AllowInPrivate": "InPrivate browsing is allowed on corporate networks.",
    "Configuration_securityEnabled_DESC": "Set / cancel the IP limit function of administrator",
    "LANG_POLICY_conditionConfig": "Set Policy Conditions",
    "MdmPolicyControlName_safariAcceptCookies": "Whether you accept cookies",
    "policyTargetTitle": "Target of Policy Application",
    "LANG_POLICY_InvokedTargetListDetail": "Selected policy applied target list",
    "LANG_NormalPolicy": "Normal",
    "AUDIT_ControlAPService_bsID": "bsID",
    "sourceUsername": "ID",
    "MdmPolicyControlName_AllowSharedUserAppData": "multiple users of the same app can share data.",
    "AUDIT_ThirdPartyDeptService_orderNum": "orderNum",
    "MESSAGE_ALERT_CONFIRM_INIT": "Do you want to initialization?",
    "RC_RESET": "Factory reset",
    "AUDIT_UserDeviceService_lost": "lost",
    "PolicyControl_new_category_2000": "Password Management",
    "MdmPolicyControlName_DevicePasswordHistory": "Device Password History",
    "handleClose": "Issue resolution",
    "PolicyControl_new_category_2001": "Allowed Device",
    "PolicyControl_new_category_2002": "Network Management",
    "PolicyControl_new_category_2003": "App Management",
    "LANG_BeconCondition": "Beacon Device Condition",
    "controlId": "Item (s)",
    "LANG_CompanyAddPopup": "Add company",
    "LANG_App_Upload_Version_Not_compared": "There is higher version upload app.",
    "AUDIT_VersionedAppService_id": "id",
    "PolicyControl_new_category_2004": "Backup Management",
    "LANG_msgModify2": "modify",
    "AUDIT_UserDeviceService_admin": "admin",
    "AUDIT_ReservedVisitorService_createDate": "[EN]생성시간",
    "ManageWhiteApps": "White app management",
    "MdmPolicyControlName_allowMultiplayerGaming": "Allow multiplayer games",
    "AUDIT_ThirdPartyDeptService_dept": "dept",
    "AppExcute": "Run App",
    "RC_APP_REMOVE": "Delete app",
    "AUDIT_UserDeviceService_lastAccessTime": "lastAccessTime",
    "ACTION_MdmLogController_setClosed": "Shut down the security issues",
    "ISSUE_SOLVE_ERROR_DBLimitCritical": "Storage Critical limit exeed.",
    "LANG_DEVICE_RemoteCommandShort": "Remote",
    "LANG_LOG_DeviceLatest": "Recent device",
    "Title_CEO": "CEO",
    "MdmPolicyControlName_killProcess": "Status of blocking ginger bread app process",
    "AUDIT_AppService_certificate": "certificate",
    "DeviceResource_1001": "OS",
    "LANG_deviceCount2": "Device count",
    "DeviceResource_1000": "Service provider",
    "DeviceResource_1003": "Manufacturer",
    "DeviceResource_1002": "Version",
    "DeviceResource_1005": "CPU",
    "LANG_Policy_ChooseLeftTree": "Please choose in the left policy tree .",
    "DeviceResource_1004": "Model",
    "LANG_mar2": "March",
    "MdmPolicyControlName_DisallowConvenienceLogon": "Disallow convenience logon",
    "jqGrid_delete": "Delete",
    "MdmPolicyControlName_AllowTelemetry": "Allow Telemetry",
    "LANG_LOG_Statistics": "Statistics",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_BUTTON_DETAIL": "View Beacon Proximity List",
    "LANG_ALT_remoteCommand": "Administrator remotely control the device.",
    "LANG_policyPublishToSaveDesc": "Save To Policy",
    "MdmPolicyControlName_wirelessNetworkAuthorization": "Wireless network",
    "Title_000001700": "서기",
    "LANG_QrCode_Size_MIN": "MINIMUN Size",
    "LANG_AP_DETAIL": "Detail AP(Access Point)",
    "SourceType_SERVER_SYSTEM": "System",
    "DeviceResource_1008": "USIM Serial",
    "DeviceResource_1009": "Country",
    "DeviceResource_1006": "Wi-Fi Mac Address",
    "DeviceResource_1007": "IMEI",
    "LANG_ApCondition": "Wireless AP Condition",
    "ACTION_DeviceMDMService_sendResponse": "The remote command results to the transport and communication devices",
    "ISSUE_SOLVE_ERROR_DBLimitWarning": "Storage Warning limit exceed.",
    "AUDIT_DefenceSettingService_category": "category",
    "AUDIT_LocationService_altitude": "altitude",
    "LANG_createDateTime": "Registration time",
    "LANG_LocationPolicyNonApplyList": "UnappliedList",
    "PASSWORD_QUALITY_NUMERIC": "The numbers included",
    "AUDIT_UserDeviceService_pushId": "pushId",
    "LANG_IssueCategory": "Issue Category",
    "LANG_other": "Other",
    "LANG_DEVICE_LostReport": "Report of loss/theft",
    "AUDIT_LocationService_address": "address",
    "AUDIT_UserDeviceService_vendorPushEnabled": "vendorPushEnabled",
    "Holiday": "Holidays",
    "Configuration_dbmsCriticalLimitsize_DESC": "Exceed allowable rates DBMS SERVER set the allowable capacity (unit:%, default: 90%)",
    "LANG_APP_Name": "APP",
    "AUDIT_LocationService_description": "description",
    "LANG_SMS_Send_Failure": "SMS SEND Failure.",
    "TermQuery": "Inquiry",
    "LANG_ManageApps": "Office app management",
    "MdmPolicyControlName_AllowAdvertising": "device can send out Bluetooth advertisements.",
    "AUDIT_BeaconAreaService_description": "description",
    "AUDIT_ProductDeviceService_osVersion": "osVersion",
    "MdmPolicyControlName_AllowAddingNonMicrosoftAccountsManually": "Allow Adding Non-Microsoft Accounts Manually",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_SELECT_IN": "Select Incoming Beacon Proximity",
    "AUDIT_ThirdPartyCompanyService_apiKey": "apiKey",
    "LANG_LocationPolicyPresentCondition": "LocationPolicy Enforcement Status",
    "LANG_SETTING_DeptManagement": "Organization Management",
    "LANG_policyTargetCnt": "Target Cnt",
    "LANG_POLICY_CONDITION_TITLE_TYPE_TIME_IS_HOLIDAY": "Holiday",
    "LANG_LocationConditionDesc": "Set the policy conditions of Telecom (CELL ID) based.",
    "MdmPolicyControlName_AllowSmartScreen": "SmartScreen is allowed.",
    "MdmPolicyControlName_useExternalSDCard": "Using an external SDCARD",
    "AL_UsbStorageLog": "USB Storage Log",
    "LANG_Self_Device_backup_device": "Backup Device ",
    "ClientInstalled": "The app is installed",
    "WLAN_SCANMODE_DEFAULT": "Default",
    "AUDIT_NoticeTargetService_updateDate": "updateDate",
    "LANG_ManagerEdit": "Modify Administratior",
    "execCommand": "Executive command",
    "Configuration_sessionMaxInactiveInterval_DESC": "Set a time for automatic termination of session (default value is 300 seconds)",
    "LANG_LOC_address": "Address",
    "AUDIT_LocationService_createDate": "createDate",
    "Audit_DefenceSettingService": "System Configuration",
    "LANG_LOC_radius": "Radius",
    "RC_RM_1": "Delete critical information",
    "LANG_POLICY_PolicyConfigShort": "Policy",
    "Configuration_maxSessionCnt_DESC": "Set a maximum number of log on session for same administrator ID (default value is 1)",
    "RC_RM_2": "Remove all apps from the device",
    "ERROR_AdminLocked": "User specified password has been locked by {0} failed.",
    "LANG_Self_Desc_date_to_location": "Recent requested date : ",
    "LANG_ManageMain": "The main screen",
    "LANG_HolidayTitle": "Holiday",
    "LANG_ManageAccessPoint": "Wireless AP management",
    "LANG_DEVICE_TotalInfo": "Device information",
    "MdmPolicyControlName_autoUpdateSec": "MDM auto-upgrade status",
    "LANG_sep2": "September",
    "LANG_Office_Off_Policy": "Office App OFF",
    "LANG_LOG_AuditLog": "Audit Log",
    "AL_AppsInfoOK": "Succeeded to get device app install information.",
    "AUDIT_LocationService_radius": "radius",
    "LANG_DEVICE_TotalStatus": "Device Status",
    "MESSAGE_ALERT_ONLY_SELECT_TARGET": "You have to choose only one target of {0}.",
    "LANG_DeviceRemoteCommand": "Device remote command",
    "Configuration_dbmsWarnLimitsize": "Permitted capacity warning allowed DBMS SERVER rate setting",
    "CRITICALLOG": "Send critical log only",
    "MdmPolicyControlName_userNotification": "User notification",
    "LANG_NOTICE_NoticeManagementDetail": "Manage notification for the device user.",
    "LANG_WP_federated_enrollment_item_email_address": "Email Address",
    "AUDIT_VisitorUserService_externalVisitNo": "LDCC visitor Number",
    "LANG_POLICY_CONDITION_TITLE_TYPE_TIME_SET": "Set Time",
    "LANG_ERROR_UserStatusIsNotUseUserMessage": "Non Using User",
    "RC_OUTCALL_ON": "Allow to make a call",
    "ERROR_ON_SENDING": "Transmission failed",
    "conditionName": "Condition name",
    "Configuration_adminAccessIP1_DESC": "Allow access IP 1 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "BLACKAPPHIDE": "Hiding",
    "MdmPolicyControlName_forceEnabledWiFi": "Impose using WiFi",
    "APPCONTROLWHITE": "white app",
    "MESSAGE_ALERT_NO_POLICY_ITEM": "Policy item is not set.",
    "MdmPolicyControlName_AllowDeveloperUnlock": "Allow Developer Unlock",
    "MdmPolicyControlName_MDMRBS0000000001": "Scheduled backup",
    "MdmPolicyControlName_MDMRBS0000000002": "Scheduled backup cycle",
    "MdmPolicyControlName_MDMRBS0000000003": "Scheduled backup date",
    "MdmPolicyControlName_MDMRBS0000000005": "Scheduled backup time",
    "PolicyControl_new_category_desc_3001": "Sets the policy for controlling the device unit.",
    "MdmPolicyControlName_MDMRBS0000000004": "Scheduled backup day",
    "PolicyControl_new_category_desc_3002": "Sets the application control policy for the device.",
    "LANG_ReservedVisitorManagementDetail": "Visitors to manage the reservation list.",
    "PolicyControl_new_category_desc_3000": "Set the default information for the management of your iOS device.",
    "AUDIT_UserService_lockCnt": "lockCnt",
    "AUDIT_VisitorUserService_id": "id",
    "AL_appRemove": "App delete",
    "MdmPolicyControlName_allowSystemBrowser": "System browser block status",
    "AUDIT_UserService_lock": "lock",
    "LANG_deviceCount": "Number of device",
    "LANG_PERSONNEL_ReservedVisitorManagement": "Reservations visitor management",
    "PolicyControl_new_category_desc_3004": "Set the control policy of Safari.",
    "PolicyControl_new_category_desc_3003": "Sets the cloud service control policy by iCloude.",
    "TargetCompany": "Company",
    "AUDIT_ReservedVisitorService_employeeComapny": "[EN]방문자직원회사",
    "PolicyControl_new_category_desc_3005": "Set the password policy for the security of the device.",
    "AUDIT_HolidaysService_name": "name",
    "LANG_QrCode_Size_MAX": "MAX Size",
    "LANG_ManagePolicyCondition": "Policy management",
    "LANG_ApConditionDesc": "Set the policy conditions of  WIFI AP (Access Point) based.",
    "devcieBasicInfo": "General information of the device",
    "AUDIT_UserService_isUse": "Is Use",
    "MESSAGE_ALERT_NO_REMOTE_HISTORY": "The history of the remote command does not exist.",
    "AUDIT_LocationService_id": "id",
    "Label_LastPolicyApplied": "Apply policy",
    "MESSAGE_ALERT_LOST_REQUIRED": "When you send a report of loss/urgent message, input of {0} is required.",
    "AUDIT_ProductDeviceService_vendorName": "vendorName",
    "LANG_SMS_Confirm": "There is a history of SMS sent. Try again?",
    "LANG_IsRooted": "Rooted Devices",
    "MESSAGE_ALERT_NO_DIVICE_LOCATION": "The location information of the device does not exist.",
    "MdmPolicyControlName_AllowWiFi": "Allow WiFi",
    "LANG_isRegistered": "Registered",
    "BSID": "BSID",
    "RC_UNENROLLMENT_MDM": "Device Unenrollment MDM",
    "MdmPolicyControlName_DevicePasswordEnabled": "Device Password Enabled",
    "PasswordPolicyNumber": "Numbers",
    "LANG_LOC_locationid": "Location name",
    "AUDIT_ReservedVisitorService_employeePosition": "[EN]방문부서담당자직책",
    "RC_INIT": "The command init",
    "ISSUE_SOLVE_SamsungSDK": "MDM app, not signed with Samsung SDK, has been installed to Samsung device. Please distribute Samsung SDK signed MDM app.",
    "LANG_DeviceStatus": "Device status",
    "MdmPolicyControlName_allowCamera": "Allow Camera",
    "LANG_OS": "OS",
    "UserDepartmentChange": "Changes the user Department",
    "AddAccessPoint": "Add the wireless AP",
    "LANG_WP_federated_enrollment_item_confirm_button": "Send",
    "MdmPolicyControlName_AllowBluetooth": "Allow Bluetooth",
    "AUDIT_VersionedAppService_category": "category",
    "SourceType_EXT_API_CALL": "API calls",
    "AUDIT_NoticeService_statusCode": "statusCode",
    "BUTTON_SAVE_SETTING": "SAVE SETTING",
    "RC_GET_ALL_APPS": "Installed app views",
    "LANG_Policy_select_all": "Select All",
    "LANG_targetType": "Type",
    "AUDIT_UserService_roleType": "roleType",
    "LANG_sun": "Sun",
    "LANG_POLICY_NAME": "Policy",
    "LANG_APP_agentIsInstalled": "Agent app installation status",
    "LANG_TOP_DeviceManagement": "Device Control",
    "PasswordConfirm": "Password confirmation",
    "LANG_LOC_longitude": "Longitude",
    "RC_ERROR_ON_EXECUTING": "The command execution failed",
    "MdmPolicyControlName_AllowPrepairing": "specific bundled Bluetooth peripherals to automatically pair with the host device.",
    "LANG_REMOTE_LOST_CLEAR": "Do you want your device lost or stolen clear?",
    "LANG_Search2": "results",
    "LANG_Search1": "Total",
    "LANG_Search4": "Total 0 result",
    "LANG_DEVICE_RemoteManagement": "Remote Management",
    "LANG_Search3": "case",
    "LANG_LOGIN_MAX_OVER_ERROR": "The same account / access rights of the administrator to the end of this connection.",
    "LANG_APP_UserAppState": "User app status",
    "AUDIT_UserService_company": "company",
    "AL_TAToken_ISSUE": "TAT Token is Issue",
    "LANG_DEVICE_LostReportShort": "Lost",
    "EditProductDevice": "Modify device type",
    "MdmPolicyControlName_allowManagedAppsCloudSync": "Allow iCloud App Management",
    "LANG_Windows_Auto_Update04": "Auto install and restart without end-user control.",
    "LANG_Windows_Auto_Update05": "Turn off automatic updates.",
    "AUDIT_HolidaysService_updateDate": "updateDate",
    "LANG_DeviceRemoteManageDetail": "Administrator remotely control the device.",
    "LANG_Windows_Auto_Update01": "Auto install the update.",
    "LANG_Windows_Auto_Update00": "Notify the user.",
    "RC_LOCK_ON": "Device system lock",
    "LANG_CATEGORY_DEVICE": "Device",
    "LANG_Windows_Auto_Update03": "Auto install and restart at a specified time.",
    "GeneralLoginError": "Username or password is invalid. Please enter it again.",
    "LANG_Windows_Auto_Update02": "Auto install and restart.",
    "MdmPolicyControlName_ScheduledInstallDay": "Enables the IT admin to schedule the day of the update installation.",
    "LANG_APP_FileName": "File name",
    "AL_restoreFail": "Recovery failed",
    "SourceType_DEVICE": "Terminal",
    "selectTargetNotice": "Select",
    "LANG_ERROR_ReachedMaxSessionCount": "Maximum log exceeds the available session.",
    "LANG_APP_BlackAppManagement": "Black app management",
    "LANG_DefaultPolicyInfo": "Information To Default Policy",
    "AUDIT_ControlAPService_auth": "auth",
    "LANG_POLICY_ResetFactoryDefaults": "Reset to factory default",
    "AUDIT_ProductDeviceService_id": "id",
    "LANG_REMOTE_DEVICE_EXPLANATION": "You can control the function of lost device. Select the remote command and press [Command execution] button.",
    "LANG_NoData_remoteCmdList": "No data",
    "ACTION_LoginSuccess": "Manager, you will see a login successful",
    "policyPublishSuccessful": "Successfully saved and distributing the policy.",
    "LANG_Policy_ChooseTopPolicy": "Please choose in the top policy",
    "LANG_List": "List",
    "MESSAGE_ALERT_CONFIRM_SAVE": "Do you want to save?",
    "BUTTON_OK": "OK",
    "LANG_Self_Device_status": "Device status",
    "MdmPolicyControlName_AllowAllTrustedApps": "non Windows Store apps are allowed.",
    "Status_OPENED": "Generation",
    "LANG_LostTotal": "Total number of lost",
    "NOTNOW": "Agent Wait",
    "AUDIT_ProductDeviceService_status": "status",
    "MdmPolicyControlName_allowInAppPurchases": "Allow APP purchases",
    "LANG_LogOut": "Logout",
    "BUTTON_DELETE": "DELETE",
    "Audit_VersionedAppService": "App",
    "LANG_DEVICE_device": "Device",
    "LANG_LOC_searchCountIs": "Number of moved routes by user (ex. 10 - Shows 10 moved routes)",
    "LANG_Normal": "Normal",
    "LANG_PERSONNEL_VisitorManagementLatest": "latest to Visitor.",
    "MdmPolicyControlName_forceC2dm": "GCM (formerly C2DM) use force?",
    "LANG_SearchResultTotal": "Total {0} result(s).",
    "LANG_dec2": "December",
    "LANG_APP_publishTargetInfo": "Publich APP Target Info",
    "AUDIT_ReservedVisitorService_employeeDeptName": "[EN]직원부서이름",
    "LANG_ManageCheck": "chk",
    "LANG_Self_Desc_location_to_device": "Depending on the requested functionality the network environment and the state of the device can also be long or fail.<br>When you run the function execution history will be passed to the device.",
    "LANG_osType": "OS Type",
    "LANG_VendorName": "Manufacturer",
    "MESSAGE_ALERT_CONFIRM_DELETE": "Do you want to delete?",
    "LANG_INITPW_INIT_INFORMATION_MESSAGE": "● You need to change password when you login first.",
    "MdmPolicyControlName_MaxiumLog": "Maximum log count",
    "LANG_EXECUTION_SUCCEEDED": "Push execution is succeeded. ",
    "AUDIT_UserDeviceService_reConnectCount": "reConnectCount",
    "Audit_BeaconAreaService": "Beacon Area",
    "AUDIT_LocationService_latitude": "latitude",
    "ajaxErrMsg": "Please try again error ajax communication.  n.",
    "LANG_NUMERIC_ENG_CHECK": "[{0}] is English and numeric characters only.",
    "LANG_Rooted": "Rooted",
    "codeGroup": "Code group",
    "LANG_POLICY_CONDITION_BIZ_APP": "Business",
    "LANG_Self_Device_lock_status": "Lock status",
    "LANG_USER_DELETE_FAILED": "Deletion failed. Some users are using MDM.",
    "AL_policyAppsApplyOK": "App Policy enforcement succeeded",
    "AUDIT_ProductDeviceService_updateDate": "updateDate",
    "LANG_POLICY_condition": "Policy Conditions",
    "LANG_LocationManagement": "Location management",
    "AUDIT_UserService_email": "email",
    "LANG_LOG_DeviceStatusByGroup": "Device status by group",
    "AL_TAToken_Expired": "TAT Token is Expired",
    "AL_adminAcquire": "Device Manager properties",
    "LANG_LOC_remoteCommandListDetail": "You can check remote command history of selected device.",
    "MdmPolicyControlName_AllowManualRootCertificateInstallation": "Allow Manual Root Certificate Installation",
    "Configuration_encodeDvc": "DVC encoding?",
    "LANG_UserName": "User name",
    "LANG_LocationPolicyDeptPresentCondition": "Status of organization-specific policies",
    "AUDIT_UserDeviceService_lockDevice": "lock Device",
    "MdmPolicyControlName_AllowIdleReturnWithoutPassword": "Allow Idle Return Without Password",
    "SSID": "SSID",
    "Label_LastAccessDate": "Last access date",
    "EditVarification": "Modify your app verification log",
    "LANG_APP_NoneAppAdd": "Add general app",
    "LANG_NoRoot": "No root",
    "policyDesc": "Policy description",
    "policyControlClassList": "Additory MDM functions",
    "LANG_day17": "17",
    "LANG_day16": "16",
    "LANG_day19": "19",
    "fileNotFound": "The system cannot find the file \"{0}\".",
    "LANG_TargetDeptName": "Department name",
    "LANG_day18": "18",
    "LANG_day10": "10",
    "LANG_day11": "11",
    "LANG_day12": "12",
    "LANG_SMS_Send": "Are you sure you want to send the SMS?",
    "LANG_day13": "13",
    "LostUser": "User",
    "Configuration_deviceMaximumInactiveTime": "Time limit of disconnection between a device and sever(s)",
    "LANG_day14": "14",
    "LANG_ManageApplication": "Applid",
    "LANG_day15": "15",
    "cteateDateTime": "Registration date",
    "LANG_Windows_Bluetooth00": "Disallow.",
    "LANG_Windows_Bluetooth01": "Reserved.",
    "LANG_Valid_UUID_MSG": "This position is not valid UUID input",
    "LANG_Windows_Bluetooth02": "Allow.",
    "BUTTON_REMOTE": "REMOTE",
    "MdmPolicyControlName_c2dmUse": "Whether to use the GCM (formerly C2DM)",
    "SAFARIACCEPTCOOKIES_NO_USE": "No Use",
    "LANG_day08": "08",
    "LANG_day07": "07",
    "LANG_day06": "06",
    "LANG_day05": "05",
    "LANG_day09": "09",
    "LANG_day03": "03",
    "LANG_day04": "04",
    "LANG_day01": "01",
    "Status_PASSIVE": "Inactive",
    "LANG_day02": "02",
    "AUDIT_ThirdPartyDeptService_typeCode": "typeCode",
    "LANG_Policy_Not_SubjectPolicy": "There is no subject to which the policy applies.",
    "AUDIT_VersionedAppService_allowedUse": "allowedUse",
    "NoticeTargetType": "Target",
    "LANG_mar": "Mar",
    "LostDept": "Department",
    "LANG_APP_notInstalled": "Not installed",
    "ALLOW_TELEMETRY_RESTRICT": "Restrict",
    "LANG_Weekly": "Weekly",
    "Severity_FATAL": "The seriousness of the",
    "Configuration_passwordMinLength_DESC": "Set a minimum length of administrator/user password (default value is 9)",
    "LANG_day30": "30",
    "AUDIT_ProductDeviceService_osType": "osType",
    "LANG_day31": "31",
    "MdmPolicyControlName_allowSharedStream": "Allow Shared Photo Stream",
    "LANG_IsLostIng": "Lost progress",
    "LANG_may": "May",
    "LANG_SETTING_UserAgreementManagement": "User Agree Management",
    "AUDIT_BeaconAreaService_id": "ID",
    "LANG_LostStatus": "Lost status",
    "LANG_USER_Init": "User Initialization",
    "LANG_Windows_Auto_Update_Day01": "Sunday.",
    "LANG_Windows_Auto_Update_Day02": "Monday.",
    "LANG_Windows_Auto_Update_Day00": "Every day.",
    "LANG_Windows_Auto_Update_Day05": "Thursday.",
    "LANG_day29": "29",
    "LANG_LOC_altitude": "Altitude",
    "AUDIT_NoticeTargetService_name": "name",
    "LANG_Windows_Auto_Update_Day06": "Friday.",
    "LANG_day28": "28",
    "LANG_Windows_Auto_Update_Day03": "Tuesday.",
    "LANG_day27": "27",
    "AUDIT_ThirdPartyDeptService_id": "id",
    "LANG_Windows_Auto_Update_Day04": "Wednesday.",
    "LANG_day25": "25",
    "Name": "Name (s)",
    "LANG_day26": "26",
    "LANG_day23": "23",
    "LANG_day24": "24",
    "LANG_Windows_Auto_Update_Day07": "Saturday.",
    "LANG_day21": "21",
    "LANG_day22": "22",
    "LANG_day20": "20",
    "LANG_LOG_InstallLog": "Device Installation Status",
    "LANG_APP_PreviousVersion": "Previous",
    "AUDIT_ProductDeviceService_name": "name",
    "WARNLOG": "Send warning and dangerous log only",
    "ManageLog": "Log management",
    "LANG_Office_On_Policy": "Office App ON",
    "AUDIT_NoticeService_creator": "creator",
    "MdmPolicyControlName_safariAllowAutoFill": "Allow auto-complete",
    "ServiceURL": "Service URL",
    "ADPR_USER": "User",
    "AUDIT_ProductDeviceService_odelName": "modelName",
    "RetrieveUser": "Search user",
    "LANG_deptName": "Department name",
    "LANG_ManageBeaconArea": "Beacon Area management",
    "LANG_WP_federated_enrollment_ERROR_UserNotUse": "User disabled. Please ask to your system administrator.",
    "EVERYWEEK": "Every week",
    "AUDIT_UserDeviceService_createDate": "createDate",
    "ACTION_ApplicationStopped": "Security system / Audit log shut down",
    "InstallClientDate": "Installation date",
    "LANG_latelyLog_Graph_Comment": "from data to currently unit",
    "changeParentDept": "Change parent Department",
    "MdmPolicyControlName_AllowSaveAsOfOfficeFiles": "Allow SaveAs Of OfficeFiles",
    "Email": "Email",
    "AUDIT_BeaconAreaService_area": "area",
    "AUDIT_ReservedVisitorService_visitor": "[EN]방문객",
    "AUDIT_UserTitleService_id": "id",
    "LANG_LOG_IssueLogDetail": "Check a history of security issue.",
    "LANG_SpeedGateConditionDesc": "Set the policy conditions of Speed Gate Linded. (If Speed Gate exists)",
    "MdmPolicyControlName_AllowStorageCard": "Allow Storage Card",
    "AddVarification": "Add app verification log",
    "MdmPolicyControlName_EnableDeleteButton": "Use Delete Button",
    "EditCertificate": "Certificate change",
    "MdmPolicyControlName_AllowSharingOfOfficeFiles": "Allow Sharing Of OfficeFiles",
    "LANG_plzSelctRows": "Target is not selected",
    "MDMx9001": "Required String parameter [ {0} ] is not present",
    "LANG_MemberNum": "MemberNum",
    "ApiKey": "API key",
    "LANG_LastAccessTime": "Access time",
    "MdmPolicyControlName_AllowDoNotTrack": "Do Not Track headers are allowed.",
    "LANG_Monthly": "Monthly",
    "LANG_ManagePolicy": "Policy management",
    "LABEL_lastBackupTime": "Last backup date",
    "Audit_ProductDeviceService": "Handset",
    "LANG_logType": "Log type",
    "MdmPolicyControlName_wifiApDailyReset": "WiFi AP Daily Reset",
    "jqGrid_add": "Add",
    "AddConfiguration": "Add set",
    "MdmPolicyControlName_encOutMemory": "External memory encryption",
    "ACTION_DeviceService_unregisterDevice": "Terminals off communication",
    "LANG_POLICY_CONDITION_TITLE_TYPE_WIFI_AP_SELECT": "Select Wi-Fi AP",
    "AUDIT_UserService_accountNonExpired": "accountNonExpired",
    "LANG_PERSONNEL_VisitorManagement": "Visitor Management",
    "ISSUE_SOLVE_ERROR_UserNotUse": "Restricted User. Check \"user management\" in the \"USE\" flag.",
    "LANG_USR_user": "User",
    "LANG_LocationPolicyTotalcount": "LocationPolicy Count",
    "Operation_UPDATE": "Fix Complete",
    "LANG_Policy_was_Registered": "This Target was Registered",
    "DuplicateUsername": "The user ID is duplicated.",
    "InvalidIp": "IP is invalid.",
    "CompanyViewPopup": "Companies detail View",
    "LANG_ErrorLogin": "Username or password is invalid.",
    "AllowedIP_Question": "What is a access allowed IP?",
    "managerContact": "Transmitting number",
    "LANG_xisCompleted": "Completed {0}.",
    "LANG_USR_ConfigDetail": "Manage a information about MDM user.",
    "AddCertificate": "Add certificate",
    "Configuration_passwordCombine_DESC": "Set a type of administrator/user password (default value = numbers + English characters + special letters)",
    "Label_AdditionalUserGuideMessage": "Send additional messages to the user",
    "MdmPolicyControlName_AllowSearchToUseLocation": "Allow Search To Use Location",
    "AUDIT_BeaconAreaService_minorDc": "minorDC",
    "LANG_ManageAccessPointDetail": "What is wireless AP management? - Manage information of wireless network.",
    "LANG_jan2": "January",
    "Title_Assistant": "Assistant Manager",
    "AUDIT_PassingStatusService_signalStatus": "signalStatus",
    "LANG_POLICY_PolicyApplyStatus": "Policy Application Status",
    "AUDIT_VisitorUserService_scheduledTime": "scheduledTime",
    "LANG_ManageNotice": "Notification management",
    "LANG_REMOTE_LOST_EXPLANATION2": "and click [Report loss / theft].",
    "AUDIT_PassingStatusService_category": "category",
    "AUDIT_BeaconAreaService_minor": "minor",
    "LANG_REMOTE_LOST_EXPLANATION3": "Please click the [Report lost / stolen device] button.",
    "LANG_REMOTE_LOST_EXPLANATION1": "When your device gets lost or stolen, please enter the phone number that can reach you,",
    "LANG_POLICY_PolicySchedule_Desc": "Schedule MDM Policy transfers.",
    "AUDIT_VisitorUserService_name": "name",
    "LANG_logDateTime": "Inquiry date",
    "LANG_nov2": "November",
    "PolicyControl_new_category_desc_4002": "Sets the location information management policies.",
    "PolicyControl_new_category_desc_4001": "Set the management policy of the agent.",
    "PolicyControl_new_category_desc_4000": "Set the management policies of device log.",
    "MdmPolicyControlName_AllowMicrosoftAccountConnection": "Allow Microsoft Account Connection",
    "ERROR_UserNotUse": "Restricted User.",
    "LANG_APP_isLatest": "Latest version status",
    "MdmPolicyControlName_AllowCamera": "Allow Camera",
    "Configuration_reConnectDeviceMaximum_DESC": "Set a times limit of agent reinstallation (default is 5, scope : 1~5)",
    "LANG_ManagerID": "Admin ID",
    "AppPlatform": "App platform",
    "AUDIT_UserService_credentialsNonExpired": "credentialsNonExpired",
    "ADPR_N": "Numeric",
    "AUDIT_UserService_permAccessIp1": "permAccessIp1",
    "AUDIT_UserService_permAccessIp2": "permAccessIp2",
    "LANG_Valid_UUID_FAIL_MSG": "Beacon's UUID, Major, Minor value is Duplicate.",
    "LANG_LENGTH_CHECK": "[{0}] is no more than {1) characters.",
    "MdmPolicyControlName_allowVideoConferencing": "Allow video conferencing",
    "ACTION_MdmLogController_setFixed": "Addresses the security issues",
    "jqGrid_alert": "Warning",
    "LoginTitle": "Absolute defense management console login",
    "LANG_ManageHoliday": "Holiday management",
    "MdmPolicyControlName_screenPowerSavingMode": "Screen sleep mode",
    "Title_Manager": "Manager",
    "deviceRemoteCommand": "Device remote control",
    "LANG_Already_registered_bwApp": "Already registered in Black/White App.",
    "AUDIT_UserDeviceService_lostTime": "lostTime",
    "AUDIT_NoticeTargetService_targetType": "targetType",
    "AUDIT_UserDeviceService_rooted": "rooted",
    "LANG_LOG_SecurityIssueLatest": "Recent issue log",
    "RC_BACKUP": "Backup",
    "LANG_LostNot": "Normal",
    "LANG_POLICY_resetPassword": "Reset device password",
    "MdmPolicyControlName_heartBeatPeriod": "Heart Beat cycle",
    "Title_000001600": "선임사무원",
    "Title_000001601": "주임사무원",
    "LANG_Self_Device_lost_status": "Lost status",
    "LANG_ManagerAdd": "Add administrator",
    "ISSUE_SOLVE_AL_policyApplyFail": "The Terminal has been a failure in the application of policy. The device must be the problem.",
    "osType": "OS Type",
    "LANG_whole": "Whole",
    "MdmPolicyControlName_RestrictAppDataToSystemVolume": "Application data is restricted to the system drive.",
    "LANG_POLICY_CertificationManagementDetail": "Manage certification for white app management",
    "LANG_DeviceInfo": "Basic information of a device",
    "AUDIT_UserService_enabled": "enabled",
    "MdmPolicyControlName_AllowPasswordManager": "saving and managing passwords locally on the device is allowed.",
    "Audit_MdmPolicyService": "Policy",
    "LANG_APP_BlackAppSelection": "Black app",
    "LANG_SETTING_DeptManagementDetail": "Manage department and organization.",
    "AlertSelectDept": "Please select the Department you want to change.",
    "LANG_Notice": "Notice",
    "LANG_Lock": "Lock",
    "IpPattern": "IP pattern",
    "LANG_Self_Device_loss_device": "Loss in report device",
    "LANG_USR_Config": "User management",
    "LANG_Weekly2": "Weekly",
    "LANG_NOTICE_UserAgreementManagementDetail": "You will manage the prior consent information that has been notified to the user at the time of terminal registration.",
    "LANG_SystemManagement": "System management",
    "LANG_Detail": "Detail",
    "DetailColumn": "View details",
    "AlertSelectUser": "Select the user you want to change the Department first.",
    "LANG_APP_WhiteAppManagement": "White app management",
    "LANG_LOG_Lateset": "Recent log",
    "AL_OfficeAppOff": "Business apps is terminated",
    "LANG_beaconArea_ADD": "Add Proximity",
    "InstallDate": "Installation date",
    "LANG_POLICY_CONDITION_NAME": "Policy Condition Name",
    "LANG_POLICY_CONDITION_TITLE_TYPE_NAME": "Condition Name",
    "LANG_POLICY_HolidayManagement": "Holiday Management",
    "LANG_policyTargetTitleDetail": "Select a target for MDM policy.",
    "LANG_ALT_whteappManagement": "Allow the installed app as a approved one.",
    "ISSUE_SOLVE_DeviceManagerDisabled": "I have not activated the supplicant Device Manager. Users can send a message to activate the appliance Administrator's Guide.",
    "APPin": "PIN",
    "LANG_latestSendDate": "Latest send date",
    "AUDIT_UserDeviceService_agentId": "agentId",
    "LANG_POLICY_List": "Policy list",
    "LANG_APP_PresentCondition": "App Present Condition",
    "ERROR_AuthenticationFailed": "Authentication will fail. Authentication information and try again.",
    "PermAccessIp1": "Allowed access IP1",
    "MdmPolicyControlName_AllowAutoConnectToWiFiSenseHotspots": "Allow Auto Connect To WiFi-Sense Hotspots",
    "PermAccessIp2": "Allowed access IP2",
    "LANG_ALT_lost": "Manage lost/stolen device.",
    "BUTTON_PUBLISH": "PUBLISH",
    "MdmPolicyControlName_isAutoTime": "Automatic time synchronization",
    "RC_WIFI_SET": "WiFi AP Reset",
    "AUDIT_VisitorUserService_position": "position",
    "LANG_USR_name": "User name",
    "AUDIT_PassingStatusService_updateDate": "updateDate",
    "AL_backupFail": "Backup failure",
    "AUDIT_ReservedVisitorService_updateDate": "[EN]갱신시간",
    "LANG_SearchToLike": "Like",
    "MdmPolicyControlName_maxGracePeriod": "Password lock grace period (Min.)",
    "ERROR_DeviceIsNotSupported": "Unsupported device attempts to register the model {0}.",
    "LANG_sourceIp": "IP",
    "AUDIT_UserDeviceService_authToken": "authToken",
    "LANG_POLICY_CONDITION_TITLE_TYPE_WIFI_AP_BUTTON_DETAIL": "View Wi-Fi AP List",
    "MdmPolicyControlName_AllowSyncMySettings": "Allow Sync My Settings",
    "AUDIT_VersionedAppService_aliasGroup": "aliasGroup use",
    "AUDIT_NoticeTargetService_id": "id",
    "BUTTON_MODIFY": "MODIFY",
    "LANG_LOG_InstallLogListDetail": "If you click each name of list, you can arrange the list.",
    "LANG_IsUse": "Use Flag",
    "LANG_INITPW_ITEM_PASSWORD_1MORE": "New Password Confirm",
    "Title_000001181": "차석검사원",
    "Title_000001182": "팀장",
    "Title_000001180": "차석행정원",
    "BUTTON_RUN": "RUN",
    "Title_000001185": "책임행정원",
    "Title_000001186": "책임검사원",
    "Title_000001183": "파트장",
    "Title_000001184": "과장",
    "Severity_VERBOSE": "VERBOSE",
    "Title_000001189": "선임행정원",
    "BUTTON_FREE": "RELEASE",
    "Title_000001187": "계장",
    "Title_000001188": "주임",
    "ISSUE_SOLVE_DeviceInactiveMaximumTime": "The device has no access record for longer than appointed time",
    "AUDIT_LocationService_cellId": "cellId",
    "targetType": "Type",
    "NoticeEndDate": "End date",
    "LANG_ManageDept": "Department management",
    "LANG_POLICY_listDetail": "Check function that is applied to the selected policy condition",
    "AUDIT_ThirdPartyCompanyService_name": "name",
    "AUDIT_AppService_appAgent": "appAgent",
    "LANG_Validation_alert_searchDate_required": "The start and end dates for mandatory input value.",
    "Title_000001190": "사무국장",
    "Title_000001191": "대리",
    "Title_000001192": "선임검사원",
    "Title_000001193": "주임행정원",
    "Configuration_passwordChangePeriod_DESC": "Set the administrator/user password change cycle (unit: month, default 3 months)",
    "Title_000001194": "주임검사원",
    "Title_000001195": "행정원",
    "Title_000001196": "검사원",
    "Title_000001197": "계약직",
    "Title_000001198": "담당",
    "Title_000001199": "팀원",
    "AUDIT_ThirdPartyDeptService_parentTypeCode": "Parent Type Code",
    "ACTION_DeviceManagerDisabled": "Device manager was disabled.",
    "Severity_INFO": "Information",
    "changeDeptTitle": "Select/change the parent Department",
    "LANG_SearchToNone": "None",
    "RoleSecurityManager": "The security administrator",
    "LANG_AdminID": "Admin ID",
    "AUDIT_ProductDeviceService_createDate": "createDate",
    "LANG_POLICY_selectedTargetDetail": "Content of policy that is applied to selected target.",
    "AUDIT_ReservedVisitorService_visitType": "[EN]방문타입",
    "LANG_POLICY_ApplyTarget": "Subject of application",
    "LANG_SearchToDesc": "Whether a search string that contains the characters of the search criteria.",
    "ALLOW_TELEMETRY_NOT": "NotAllowed",
    "BUTTON_REFRESH": "REFRESH",
    "Title_General": "General Manager",
    "AUDIT_UserDeviceService_unRegisteredDate": "unRegisteredDate",
    "MdmPolicyControlName_whetherToAdjustTheBrightness": "Brightness adjustment status",
    "LANG_Configuration": "Set",
    "AUDIT_ReservedVisitorService_deptName": "[EN]방문부서명",
    "LANG_ExcelImport": "Add by excel",
    "AL_ProfileDeleteToNormal": "Agent Profile UnRegister",
    "policyName": "Policy name",
    "MdmPolicyControlName_AllowCopyPaste": "Allow CopyPaste",
    "MdmPolicyControlName_AllowStoringImagesFromVisionSearch": "Allow Storing Images From VisionSearch",
    "LANG_LOC_managementIs": "What is location management? Manage a location where the MDM policy is performed.",
    "AL_USIMStatus": "USIM card status",
    "MdmPolicyControlName_AllowDiscoverableMode": "other Bluetooth-enabled devices can discover the device.",
    "AUDIT_VisitorUserService_updateDate": "updateDate",
    "LANG_PropertyName": "Setting name",
    "LANG_POLICY_COMMENT_DeploymentPolicy1": "After you add or midify policy,",
    "LANG_NOTICE_Send": "Send notice",
    "LANG_POLICY_COMMENT_DeploymentPolicy2": "click [Distribute policy] button located on the top and bottom of the page",
    "AUDIT_DefenceSettingService_name": "name",
    "IsRegistered": "Device registration",
    "LANG_PropertyValue": "Setting value",
    "LANG_TotalSum": "Total",
    "LANG_CATEGORY_APP": "App",
    "EditHoliday": "Holidays modified",
    "AUDIT_VisitorUserService_deptName": "deptName          ",
    "AUDIT_ReservedVisitorService_scheduledTime": "[EN]스케쥴시간",
    "LANG_SpeedGate": "Entry systems linked",
    "MdmPolicyControlName_AllowManualWiFiConfiguration": "Allow Manual WiFi Configuration",
    "LANG_msgModify": "modify",
    "ViewNotice": "View notice",
    "AddApp": "Add your app",
    "LANG_WARNING_LEVEL3_MSG": "[EN]FATAL Level : 심각한 오류에 대한 로그",
    "LANG_Validation_alert_input": "[{0}] is not valid.",
    "AL_adminLost": "In Device Manager, disable",
    "RECEIVED": "Device receipt completed",
    "Configuration_deviceRegistrationCnt_DESC": "Set a times limit of agent installation (default is 5, scope : 1~5)",
    "AUDIT_DefenceSettingService_updateDate": "updateDate",
    "LostDate": "Lost/me report date",
    "AUDIT_HolidaysService_holiday": "holiday",
    "MdmPolicyControlName_safariAllowJavaScript": "Allow JavaScript",
    "LANG_APP_BusinessAppStateCheck": "Check office app status",
    "LANG_tue": "Tue",
    "LANG_LOG_StateOS": "Device OS status",
    "LANG_APP_AgentAppState": "Agent installation status",
    "LANG_POLICY_CONDITION_TITLE_TYPE_LOCATION_SELECT": "Select Location",
    "LANG_LOC_managementGPS": "What is GPS management? Manage a location where the MDM policy is performed.",
    "Title_Deputy": "Deputy General Manager",
    "NotBefore": "Begins",
    "LANG_INITPW_UNMATCHING_PASSWORD": "There are different passwords.",
    "LANG_oct2": "October",
    "MdmPolicyControlName_AllowAutoUpdate": "Allow Auto Update.",
    "AUDIT_ThirdPartyCompanyService_createDate": "createDate",
    "LANG_APP_LastestVersion": "Latest",
    "LANG_OsVersion": "OS Version",
    "LANG_LOG_LostManagementDetail": "Deivce Lost/Stolen Status.",
    "LANG_SETTING_NoticeManagementShort": "Notice",
    "Configuration_reConnectDeviceMaximum": "Times limit of agent reinstallation",
    "AUDIT_UserService_androidDownLoadUrl": "AndroidDownloadURL",
    "AUDIT_UserDeviceService_lock": "lock",
    "MESSAGE_ALERT_SUCCESS_REQUEST2": "Your request is processed succesfully.",
    "Audit_Pkcs12CertificateService": "Certificate",
    "AUDIT_BeaconAreaService_minorSc": "minorSC",
    "AuditLog": "The audit log",
    "LANG_PERSONNEL_MemberManagement": "Member Management",
    "Validation_phoneNumber": "Invalid phone number.",
    "MdmPolicyControlName_allowSafari": "Allow Safari",
    "RC_IGNORE": "The command ignored",
    "EditApp": "Change your app",
    "LANG_SystemSettingsDetail": "Set a system for MDM service.",
    "Configuration_passwordMaxLength_DESC": "Set a maximum length of administrator/user password (default value is 16)",
    "APAuth": "AUTH",
    "AUDIT_UserTitleService_createDate": "createDate",
    "AL_OfficeAppOn": "Business apps is excuted",
    "AUDIT_ReservedVisitorService_authToken": "[EN]인증토큰",
    "Configuration_systemEmail": "System email address",
    "LANG_DEVICE_RemoteCommand": "Remote command",
    "LANG_POLICY_CONDITION_TITLE_TYPE_BEACON_AREA_SELECT": "Select Beacon Proximity",
    "AUDIT_VersionedAppService_updateDate": "updateDate",
    "RC_SIREN_ON": "Siren",
    "LANG_Self_Desc_not_device": "There is no registered device.  Please use after registration.",
    "Configuration_passwordChangePeriod": "Administrator password change cycle",
    "Title_000001220": "감독관",
    "Title_000001221": "인턴",
    "Title_000001222": "현장대리인",
    "Status": "Status",
    "LANG_WP_federated_enrollment_init_message": "User Authentication",
    "LANG_GPSCondition": "Location Condition - GPS",
    "Configuration_maxSessionCnt": "Maximum number of log on session at the same time",
    "LANG_Title_Group": "Organization Info",
    "ALLOW_LOCATION_MANDATORY": "Mandatory",
    "LANG_TOP_PolicyManagement": "Policy",
    "ManagementName": "User name",
    "IsNewVersion": "The latest?",
    "jqGrid_view": "Read more about our",
    "MdmPolicyControlName_requireAlphanumeric": "Alphanumeric required?",
    "MdmPolicyControlName_SendIntranetTraffictoInternetExplorer": "To send intranet traffic over to Internet Explorer.",
    "Title_000001217": "부위원장",
    "Title_000001218": "간사",
    "Title_000001219": "노조위원장",
    "VirusResult": "Scan results",
    "LANG_DELETE_ADMIN_NOT_DELETE": "Delete Admin account can not be changed or deleted.",
    "MdmPolicyControlName_getCmdsOnConnected": "Reconnect: Command transmission status when reconnected",
    "Title_000001210": "총무",
    "AUDIT_ReservedVisitorService_companyName": "[EN]방문자회사",
    "Title_000001212": "수석연구원",
    "LANG_EntryPolicyTarget": "Target of Entry Policy Application",
    "Title_000001211": "TF팀원",
    "Title_000001214": "책임연구원",
    "AL_policyApplyFail": "Policy enforcement failed",
    "Title_000001213": "보조연구원",
    "Title_000001216": "연구원",
    "Title_000001215": "선임연구원",
    "AddCompany": "Add organization",
    "LANG_LOC_createDate": "Reg. Date",
    "LANG_POLICY_HolidayManagementDetail": "Manage holiday for MDM policy that is performed during holiday.",
    "LANG_DEPT_company": "Company",
    "MdmPolicyControlName_allowActivityContinuation": "Allow activity continuation",
    "Configuration_clientTimeoutSec": "Time limit of device response (seconds)",
    "alertTitle__info": "Notification",
    "LANG_POLICY_conditionDetail": "Check the policy condition that is applied to the selected policy",
    "LANG_AppDownloadList": "Downloaded app list",
    "Title_000001208": "TF팀전담",
    "LANG_execCommand": "Executive command",
    "Title_000001209": "TF팀지원",
    "AUDIT_NoticeTargetService_targetId": "targetId",
    "LANG_Self_Device_find_device": "Find device",
    "Title_000001206": "ODA T/F팀장",
    "Title_000001207": "TF팀간사",
    "LANG_POLICY_CertificationManagement": "Certification Management",
    "AUDIT_DefenceSettingService_id": "id",
    "Title_000001201": "회장",
    "Title_000001200": "T/F팀장",
    "Title_000001205": "스마트워크추진TF팀장",
    "Title_000001204": "사랑나눔회장",
    "deviceInfoSearch": "Check basic information of a device",
    "StartDateValidate": "Start date is later than the end date.",
    "Title_000001203": "성과관리팀장",
    "Title_000001202": "신성장T/F팀장",
    "APDesc": "Description",
    "MESSAGE_ALERT_NOT_EXIST_APP": "There is no file or URL of {0} App.",
    "BUTTON_BACKUP": "BACKUP",
    "LANG_modifyNoneApp": "Modify general app",
    "LANG_APP_WhiteAppSelection": "White app",
    "LANG_POLICY_APPLICATION_COMPLETE": "Policy has been applied",
    "ERROR_UserLoginFailed": "User login failed.",
    "MdmPolicyControlName_forceEnbaledGPS": "Impose using GPS",
    "MdmPolicyControlName_blockCallByPolicy": "Call blocking",
    "Configuration_adminAccessIP4_DESC": "Allow access IP 4 ex) 192.168.0.1, 192.168.0.*, 192.168.0.1-255",
    "RC_APP_INSTALL": "App installation",
    "LANG_ManageAddressMapToLatitudeLongitude": "Appli D&K",
    "RC_NOTNOW": "Agent Wait",
    "ERROR_DeviceIsNotActivatedForUse": "The terminal type is not activated. You have to activate the terminal type, if you want to allow corresponding device model.",
    "LANG_AccessOutPolicyDesc": "Access Policy Out Setting",
    "LANG_BeaconCondition": "Beacon Device Condition",
    "LANG_Consent_Person_info_Consent": "Consent",
    "LANG_WindowPhone": "Windows",
    "AL_SDCardStatus": "SD card status",
    "LANG_logStatus": "Status",
    "LANG_NotRegistered": "Not registered",
    "LANG_network_bad": "Bad",
    "LANG_APP_installed": "Installed",
    "AL_ProfileDeleteToabNormal": "Agent Profile UnRegister(abNormal)",
    "LANG_network_good": "Good",
    "LANG_UserManagement": "User management",
    "ACTION_SystemLockedRemoteSecureDataRemoved": "System locked because secure data removed",
    "AddDept": "Add department",
    "ERROR_UserIpNotAllowed": "Is a disallowed IP, contact your administrator.",
    "AUDIT_UserService_dept": "dept",
    "LANG_Lost": "Lost",
    "LANG_BeaconAreaDescription": "Description",
    "AppFile": "App files",
    "MdmPolicyControlName_usimCardLock": "Usim lock set",
    "LANG_writer": "Registrant",
    "LANG_LastSyncTimes": "Policy Apply Time",
    "Configuration_scepUrl": "SCEP URL",
    "LANG_Visitor_Header_GNB": "Visitor Management.",
    "Severity_WARN": "Warning",
    "RC_SYNC": "Synchronization",
    "LANG_REMOTE_LOST_REPORT_MESSAGE": "Lost / Stolen reported.",
    "AUDIT_ReservedVisitorService_company": "[EN]업체",
    "LANG_ERROR_UserIdNotUseMessage": "Restricted Administrator.",
    "MdmPolicyControlName_blockAppWithAllowList": "Policy of running app",
    "WLAN_SCANMODE_LOW": "Low",
    "SerialNumber": "Serial number",
    "codeName": "Code name",
    "LANG_TitleMain": "MDM ADMIN CONSOLE",
    "AUDIT_VisitorUserService_employeeDeptName": "employeeDeptName",
    "Configuration_clientTimeoutSec_ALERT": "{0} : the value must be between 300 to 1200, please specify.",
    "ACTION_DeviceRooting": "Device OS is rooted.",
    "Configuration_passwordCombine": "Combination of password",
    "LANG_noData": "No data",
    "LANG_policyCondition": "Policy Condition",
    "LANG_Unlock": "Unlock",
    "LANG_AgentLogs": "Device audit log",
    "AUDIT_PassingStatusService_createDate": "createDate",
    "RC_SET_PWD": "System unlock",
    "MdmPolicyControlName_AllowCookies": "cookies are allowed.",
    "IsRooting": "Rooting",
    "AUDIT_NoticeService_endDate": "endDate",
    "Configuration_passwordMaxLength": "Maximum length of password",
    "MdmPolicyControlName_allowAppInstallation": "Allow app installation",
    "LANG_POLICY_COMMENT_DeploymentPolicy3": "to complete policy application.",
    "LANG_REMOTE_RECEIVE_MESSAGE": "Urgent message",
    "LANG_google_calendar_url": "https://www.google.com/calendar/feeds/usa__en%40holiday.calendar.google.com/public/basic",
    "MdmPolicyControlName_pushUse": "Uses its own push server",
    "LANG_ExcelExport_UserDevice": "DeviceList",
    "AUDIT_ProductDeviceService_osName": "osName",
    "ModifyCompany": "Fix.",
    "LANG_ManageAddressMap": "Check Address",
    "AUDIT_VersionedAppService_name": "name",
    "RoleAdmin": "Manager",
    "AUDIT_VersionedAppService_createDate": "createDate",
    "LANG_logMessage": "Message",
    "TargetDevice": "Terminal",
    "MdmPolicyControlName_MinDevicePasswordLength": "Minium Device Password Length",
    "LABEL_lastRestoreTime": "Last recovery date",
    "LANG_REQUEST_IS_NOT_COMPLETED": "There are incomplete request been treated air command execution.",
    "LANG_POLICY_CONDITION_BEACON_AREA": "Beacon",
    "AUDIT_VersionedAppService_binaryFilePath": "binaryFilePath",
    "AUDIT_NoticeService_startDate": "startDate",
    "Configuration_passwordMinLength_ALERT": "{0} : the value must be between 9 to 16, please specify.",
    "AUDIT_UserDeviceService_vendor": "vendor",
    "ProductDeviceStatus": "Active status",
    "LANG_modifyOfficeApp": "Modify office app",
    "BUTTON_Cancel": "Cancellation",
    "Configuration_licenseCode_DESC": "MDM License Code for Management.",
    "LANG_INITPW_CHANGE_INFORMATION_MESSAGE": "● You need to change old password by periodical restriction",
    "LANG_APP_Latestversion": "Latest",
    "LANG_BeaconAreaName": "Area Name",

    // 4.5.1 추가 입력 
    "LANG_RealTime_Audit_Log" : "Real time audit log",
    "LANG_LocationPolicy_Status" : " Real time log of location policy (Such as In & Out)",
    "LANG_BUTTON_POLICY" : "Policy",
    "LANG_BUTTON_LOG" : "Log",
    "LANG_BUTTON_APP" : "Apps",
    "LANG_BUTTON_REMOTE" : "Remote",
    "LANG_TOTAL" : "Total",
    "LANG_SEARCHED" : "result(s)",
    "LANG_ACCESS" : "Access",
    "LANG_Consent_Person_info_Consent_Date": "Consent Date",
    "LANG_Consent_Person_info_Not_Consent": "Not Consent",
    "LANG_Recently_IssueLog": "Recently Issue Log",
    "LANG_Rooting_Count" : "Rooted Count",
    "LANG_Profile_Delete_IOS_Status" : "IOS Profile Deletue Status",
    "LANG_CONTENT" : "content",
    "LANG_Applies_Target" : "Apply Target",
    "LANG_APP_Info" : "App Information",
    "LANG_TargetDevice" : "Device",
    "LANG_Attribute_Name" : "Attribute Name",
    "LANG_TOP" : "top",
    "LANG_UseList" : "the list",
    "LANG_Report_Lost/Stolen_Device" : "Report Lost/Stolen Device",
    "LANG_Report_Lost/Stolen_Device_Sub" : "You can use this service when your device is lost or stolen.",
    "LANG_Report_Lost/Stolen_Device_Detail" : "※ When your device gets lost or stolen, please enter the phone number that can reach you, and click [Report loss / theft].",
    "LANG_Report_Lost/Stolen" : "Report Lost/Stolen",
    "LANG_Report_Lost/Stolen_Clear" : "Clear Lost/Stolen ",
    "LANG_Lost/Stolen" : "Lost / Stolen",

    "LANG_Remote_Control_Or_A_Device" : "Remote Control or a Device",
    "LANG_Remote_Control_Or_A_Device_Sub" : "You can control main function of a device remotely.",
    "LANG_Remote_Command" : "Remote Control",
    "LANG_Remote_Command_Sub" : "You can control the function of lost terminal. Select the desired function and press the Run button.",
    "LANG_Command_Execution" : "Command Execution",

    "LANG_Backup_Management" : "Backup Management",
    "LANG_Backup_Management_Sub" : "You can save critical information of a device in the server.",
    "LANG_Location_Information_Not_Available" : "Location information is not available because you did not agree to the location information.",
    "IsLastVersion": "Device LastVersion",
    "Message_Alert_Success" : "Your request has been processed.",
    "Message_Select_One_Device" : "Please select one device.",
    "Message_Select_One_Or_More_Devices" : "Please select one or more devices.",
    "Message_Select_Device" : "Please select a device.",
    "Message_Want_run_it" : "Do you really want to run it?",
    "LANG_Remote_Control_Execution" : "Remote control execution",

    "LANG_Want_BackUp" : "Do you want to back up?",
    "LANG_Want_Restore" : "Do you want to restore?",
    "LANG_Backup/Recovery" : "Backup/Recovery",

    "LANG_PolicyConfig_Sub1" : "※ After adding and modifying the policy, please save it and",
    "LANG_PolicyConfig_Sub2" : "Deploy Target Click",
    "LANG_PolicyConfig_Sub3" : "at the bottom.",
    "LANG_Group_deploy" : "Group Deploy",
    "LANG_User_deploy" : "User Deploy",
    "LANG_Device_deploy" : "Device Deploy",
    "LANG_Select_Policy_Condition" : "Select policy condition",
    "LANG_Policy_Type" : "Policy Type",
    "LANG_Policy_AreaType" : "Policy AreaType",
    "LANG_Add_Del" : "Add / Remove",
    "LANG_Around_Address" : "Around Address",
    "LANG_GPS_Name" : "GPS name",
    "LANG_Basic_Policy" : "Policy",
    "LANG_Access_Policy" : "Access Policy",
    "LANG_BeaconName" : "Beacon Name",
    "LANG_Left_Click_Tree" : "Please click on the left tree first.",
    "LANG_GPS_description" : "GPS Description",
    "LANG_Beacon" : "Beacon",
    "MESSAGE_GPS_ADD_SAVE" : "Please add gps coordinates and save.",
    "MESSAGE_GPS_3More_ADD" : "Please add 3 or more gps coordinates.",
    "MESSAGE_GPS_ADD_Fail" : "Adding gps coordinates failed, please try again after reset.",
    "MESSAGE_Distribution_Ok": "Distribution is complete.",
    "MESSAGE_Target_Add_Ok": "Completion of adding target",
    "MESSAGE_Success_Ok": "Save completed",
    "MESSAGE_Success_Fail": "Failed to save",
    "LANG_Add_Access_Policy" : "Add access policy",
    "MESSAGE_Select_Policy_Delete" : "Please select a policy to delete.",
    "MESSAGE_Want_Delete": "Are you sure you want to delete it?",
    "MESSAGE_Select_Policy_First" : "Please select a policy first.",
    "MESSAGE_Success_Add_Policy" : "Successful addition of policy",
    "MESSAGE_Fail_Add_Policy" : "Failed to add policy",
    "MESSAGE_Add_OneMore_Group": "Please add at least one group.",
    "MESSAGE_Add_OneMore_User": "Please add at least one user.",
    "MESSAGE_Add_OneMore_Device": "Please add at least one device.",
    "LANG_Noraml2" : "Normal",
    "LANG_Office_App" : "Office App ",
    "MESSAGE_PolicyCondition_Add" : "Policy condition added",
    "LANG_View_Detail" : "View Detail",
    "LANG_POLICY_conditionConfig_Add": "Add policy setting condition",
    "MESSAGE_Select_OneMore_App": "You must select at least one app.",
    "MESSAGE_Select_PolicyCondition": "Please select a policy condition.",
    "MESSAGE_ANY_Default_Not_Delete": "ANY defaults can not be deleted.",
    "MESSAGE_Default_Policy_Not_Delete" : "The default policy can not be deleted.",
    "MESSAGE_Policy_Add_Ok": "Policy added successfully",
    "MESSAGE_Policy_Add_Fail": "Failed to add policy",
    "LANG_LOG_DeviceStatusByAttribute" : "Device status by Attribute",
    "LANG_Rooting" : "Rooting",
    "LANG_Device_Os_Count" : "Device Count By OS",
    "LANG_LastVersion_Status": "Latest Version Installation Status",
    "LANG_Connection_Status" : "Connection status",
    "MESSAGE_SearchDate_Require": "Search date is a required condition.",
    "MESSAGE_LastDate_Less_StartDate": "Last search date can not be less than start date.",
    "MESSAGE_Search_And_Out": "Please search and print the date.",
    "MESSAGE_Select_LogType": "Please select a log type.",
    "LANG_Target_Notice_Del" : "Delete Target",
    "MESSAGE_Select_Property_LeftTree" : "Please select a property in the left tree.",
    "MESSAGE_Save_Complete" : "Saving is complete.",
    "LANG_Activation" : "Activation",
    "LANG_Disabled" : "Disabled",
    "MESSAGE_Select_Only_One" : "Please select only one.",
    "LANG_Number" : "Number",
    "MESSAGE_Enter_Company_Name" : "Please enter your company name.",
    "MESSAGE_Duplicate_Company" : "I have a company with a duplicate name.",
    "MESSAGE_Added_Complete" : "Added Complete.",
    "MESSAGE_Enter_AttributeType_Name" : "Please enter the attribute type name.",
    "MESSAGE_Name_Exist" : "The name already exists.",
    "MESSAGE_Select_Company_First": "Please select a company first.",
    "MESSAGE_Enter_Attribute_value" : "Please enter a Attribute value name.",
    "MESSAGE_AttributeCode_Name_Exist" : "Attribute code and name already exist.",
    "LANG_Use" : "Use",
    "LANG_Not_Use" : "Not Use",
    "MESSAGE_Duplicate_ID" : "Duplicate IDs exist.",
    "MESSAGE_Select_Administrator": "Please select an administrator.",
    "MESSAGE_Choose_Want_Delete": "Please choose what you want to delete.",
    "MESSAGE_Password_Check_Again": "Your password is incorrect, please check again.",
    "MESSAGE_Setting_Complete" : "Setting is complete.",
    "MESSAGE_SessionValue_lessThan300": "A session value of less than 300 can not be used.",
    "MESSAGE_Enter_Allowable_IP" : "Please enter an allowable IP address.",
    "MESSAGE_Maximum_PasswordLength_LessThan_Minimum_PasswordLength" : "The maximum password length can not be less than the password minimum length.",
    "LANG_Company_List" : "Company List",
    "LANG_Enrollment" : "Enrollment",
    "LANG_App_Install" : "App Install",
    "LANG_App_Delete" : "App Delete",
    "MESSAGE_Select_OSType" : "Please select the OS type.",
    "MESSAGE_Policy_Released" : "The policy has been released.",
    "LANG_Policy_Status" : "Policy Status",
    "BUTTON_Excel_Registration" : "Excel Registration",
    "BUTTON_Sample_download" : "Form Download",
    "LANG_APP_Not_LatestVersion": "Not current",
    "BUTTON_Excel_File_Registration" : "Excel file registration",
    "LANG_Result" : "Result",
    "MESSAGE_Select_User_First": "Please select a user first",
    "MESSAGE_Add_Attribute_First" : "Please add the attribute first.",
    "LANG_Excel_User_Registration" : "Excel user registration",
    "MESSAGE_Enter_Password" : "Please enter a password.",
    "MESSAGE_Enter_ID" : "Please enter your ID.",
    "MESSAGE_One_Attribute_Required" : "At least one attribute is required.",
    "LANG_Period_Search" : "Period Search",
    "LANG_MDM_ManagerPage" : "This is the MDM Manager page.",
    "LANG_Enter_ID_Password" : "Please enter your ID and password.",
    "ERROR_Login_Failed" : "Login failed.",
    "BUTTON_Reset" : "RESET",
    "MESSAGE_Enter_Address" : "Please enter your address.",
    "MESSAGE_Three_Or_More_Coordinates" : "Please take three or more coordinates.",
    "AL_EmergencyUnlockOK" : "EmergencyUnlock Log"
};


// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/translate/lang-en.ts